/* ==========================================================================
   UK Redesign — shared behaviour
   No autoplay, no auto-rotating carousels. Motion only on tap/swipe.
   Cart writes go through the theme's own window.refreshCartContents so the
   existing offcanvas cart keeps working untouched.
   ========================================================================== */
(function () {
  'use strict';

  /* The asset is included by every uk-* section, so it can be requested more
     than once on a page. Only the first execution does anything. */
  if (window.UK && window.UK.__loaded) return;
  var UK = (window.UK = window.UK || {});
  UK.__loaded = true;

  /* ---------------- money ---------------- */
  var gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  UK.money = function (cents) {
    return gbp.format((Number(cents) || 0) / 100);
  };
  UK.money0 = function (cents) {
    var v = (Number(cents) || 0) / 100;
    return v % 1 === 0 ? gbp.format(v).replace('.00', '') : gbp.format(v);
  };

  /* ---------------- never let a hung promise freeze a button ---------------- */
  UK.withTimeout = function (promise, ms) {
    return new Promise(function (resolve) {
      var done = false;
      var t = setTimeout(function () { if (!done) { done = true; resolve(undefined); } }, ms || 6000);
      Promise.resolve(promise).then(function (v) { if (!done) { done = true; clearTimeout(t); resolve(v); } },
        function () { if (!done) { done = true; clearTimeout(t); resolve(undefined); } });
    });
  };

  /* ---------------- ?debug=cart — on-screen log of every basket call ---------------- */
  UK.debugCart = /[?&]debug=cart/.test(window.location.search);
  UK.log = function (msg) {
    if (!UK.debugCart) return;
    var el = document.getElementById('uk-cartlog');
    if (!el) {
      el = document.createElement('pre');
      el.id = 'uk-cartlog';
      el.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;max-height:40vh;overflow:auto;z-index:99999;background:#111;color:#9f9;font:12px/1.4 monospace;padding:10px;border-radius:8px;margin:0;white-space:pre-wrap';
      document.body.appendChild(el);
    }
    el.textContent += new Date().toISOString().slice(11, 19) + ' ' + msg + '\n';
    el.scrollTop = el.scrollHeight;
  };

  /* ---------------- per-product pricing rules ----------------
     One line per product handle:  handle | coverage m² | unit | min:£off | min:£off | min:£off
     "*" is the fallback line. Coverage from a product metafield wins over the line. */
  UK.parseRules = function (text) {
    var rules = {};
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var parts = line.split('|').map(function (x) { return x.trim(); });
      if (!parts[0] || parts[0].charAt(0) === '#') return;
      var r = { coverage: parseFloat(parts[1]) || 0, unit: (parts[2] || 'panel').toLowerCase(), offs: [] };
      parts.slice(3).forEach(function (t) {
        var m = t.match(/^(\d+)\s*:\s*([\d.]+)$/);
        if (m) r.offs.push({ min: Number(m[1]), off: Math.round(parseFloat(m[2]) * 100) });
      });
      r.offs.sort(function (a, b) { return a.min - b.min; });
      rules[parts[0].toLowerCase()] = r;
    });
    return rules;
  };
  UK.ruleFor = function (rules, handle) {
    return rules[String(handle || '').toLowerCase()] || rules['*'] || { coverage: 0, unit: 'panel', offs: [] };
  };
  /* tiers as [{min, max, price}] for a base price (pence) and a rule */
  UK.tiersFor = function (price, rule) {
    var offs = (rule && rule.offs) || [];
    var tiers = [{ min: 1, max: offs.length ? offs[0].min - 1 : Infinity, price: price }];
    offs.forEach(function (o, i) {
      tiers.push({ min: o.min, max: offs[i + 1] ? offs[i + 1].min - 1 : Infinity, price: Math.max(0, price - o.off) });
    });
    return tiers;
  };
  UK.priceAt = function (tiers, qty) {
    var p = tiers[0].price;
    tiers.forEach(function (t) { if (qty >= t.min) p = t.price; });
    return p;
  };
  UK.unitWord = function (unit, n) {
    var u = unit === 'box' ? 'box' : 'panel';
    return n === 1 ? u : (u === 'box' ? 'boxes' : 'panels');
  };

  UK.globalRulesText = function () {
    var el = document.querySelector('[data-uk-rules]');
    try { return el ? (JSON.parse(el.textContent) || '') : ''; } catch (e) { return ''; }
  };
  UK.globalRules = function () { if (!UK.__gr) UK.__gr = UK.parseRules(UK.globalRulesText()); return UK.__gr; };
  /* "£79.99 per panel · £69.99 at 12+" / "£64.99 per box of 8" */
  UK.priceLine = function (price, handle, unitNote) {
    var rule = UK.ruleFor(UK.globalRules(), handle);
    var tiers = UK.tiersFor(price, rule);
    var unit = UK.unitWord(rule.unit, 1);
    var line = UK.money(price) + ' per ' + unit + (unitNote ? ' ' + unitNote : '');
    if (tiers.length > 1) { var best = tiers[tiers.length - 1]; line += ' · ' + UK.money(best.price) + ' at ' + best.min + '+'; }
    return line;
  };
  function initPriceLines(scope) {
    (scope || document).querySelectorAll('[data-uk-priceline]').forEach(function (el) {
      if (el.dataset.ukReady) return;
      el.dataset.ukReady = '1';
      var price = Number(el.dataset.ukPrice);
      if (!(price > 0)) return;
      el.textContent = UK.priceLine(price, el.dataset.ukHandle, el.dataset.ukUnitNote || '');
    });
  }
  UK.initPriceLines = initPriceLines;
  document.addEventListener('DOMContentLoaded', function () { try { UK.linkifyPhones(); initCartPage(); } catch (e) {} });
  if (document.readyState !== 'loading') { try { UK.linkifyPhones(); initCartPage(); } catch (e) {} }
  /* PDP comparison table: "Cost of a finished 3 m × 2.4 m wall" from the product's own price, tiers and coverage */
  function initWallCost(scope) {
    (scope || document).querySelectorAll('[data-uk-wall-cost]').forEach(function (el) {
      if (el.dataset.ukReady) return;
      el.dataset.ukReady = '1';
      var dataEl = document.querySelector('[data-uk-product-data]');
      if (!dataEl) return;
      var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var cur = (data.variants || []).filter(function (v) { return v.id === data.selected; })[0] || (data.variants || [])[0];
      if (!cur) return;
      var rule = UK.ruleFor(data.rules ? UK.parseRules(data.rules) : UK.globalRules(), data.handle);
      var coverage = data.coverage > 0 ? data.coverage : (rule.coverage > 0 ? rule.coverage : 0.68);
      var w = parseFloat(el.dataset.ukWallW) || 3, h = parseFloat(el.dataset.ukWallH) || 2.4, waste = 1 + (parseFloat(el.dataset.ukWaste) || 8) / 100;
      var n = Math.ceil(((w * h) / coverage) * waste);
      var each = UK.priceAt(UK.tiersFor(cur.price, rule), n);
      var tpl = el.dataset.ukWallTpl || '[total] — all in. Delivered, no fitter, [n] [unit].';
      el.textContent = tpl.replace('[total]', UK.money(n * each)).replace('[n]', String(n)).replace('[unit]', UK.unitWord(rule.unit, n));
    });
  }
  UK.initWallCost = initWallCost;

  /* ---------------- toast ---------------- */
  UK.toast = function (message, href, linkText) {
    var el = document.getElementById('uk-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'uk-toast';
      el.className = 'uk-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = '<span></span>';
    el.firstChild.textContent = message;
    var links = Array.isArray(href) ? href : (href ? [{ href: href, text: linkText || 'View basket' }] : []);
    if (links.length) {
      var wrap = document.createElement('span');
      links.forEach(function (l) {
        var a = document.createElement('a');
        a.href = l.href;
        a.textContent = l.text;
        wrap.appendChild(a);
      });
      el.appendChild(wrap);
    }
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, 8000);
  };

  /* ---------------- add-to-basket feedback (sitewide) ----------------
     Never silent. On success: open the theme's cart drawer with a "just added"
     panel at the top (Checkout / Keep shopping, plus the refund line on the
     samples page), flip the tapped button to "Added ✓" for two seconds, pulse
     the header basket count, and show the sticky checkout link. If the drawer
     cannot open, a toast with View basket · Checkout.                       */
  UK.afterAdd = function (response, opts) {
    opts = opts || {};
    var drawer = document.querySelector('#offcanvas-cart');

    function flipButton() {
      var btn = opts.button;
      if (!btn) return;
      var card = opts.card || (btn.classList.contains('uk-sample') ? btn : null);
      if (card) {
        card.classList.add('is-added');
        setTimeout(function () { card.classList.remove('is-added'); }, 2000);
        return;
      }
      if (btn.hasAttribute('data-uk-sbr-item') || btn.hasAttribute('data-uk-calc-add') || btn.hasAttribute('data-uk-sample-add')) return;
      var original = btn.dataset.ukLabel || btn.innerHTML;
      btn.disabled = false;
      btn.innerHTML = 'Added \u2713';
      setTimeout(function () { btn.innerHTML = original; }, 2000);
    }
    function pulseBadge(count) {
      document.querySelectorAll('.cart-count-badge').forEach(function (b) {
        if (typeof count === 'number') { b.textContent = count; b.removeAttribute('hidden'); }
        b.classList.remove('uk-pulse'); void b.offsetWidth; b.classList.add('uk-pulse');
      });
    }
    function stickyCheckout() {
      document.querySelectorAll('[data-uk-sticky-checkout]').forEach(function (a) { a.hidden = false; });
    }
    function fallbackToast() {
      UK.toast('Added to basket', [{ href: '/cart', text: 'View basket' }, { href: '/checkout', text: 'Checkout' }]);
    }

    if (!response || !response.ok) {
      return (response ? response.json() : Promise.resolve({})).then(function (d) {
        UK.toast((d && (d.description || d.message)) || 'Could not add to basket');
      }).catch(function () { UK.toast('Could not add to basket'); });
    }

    flipButton();
    stickyCheckout();

    var refreshed = Promise.resolve();
    if (typeof window.refreshCartContents === 'function' && drawer) {
      try { refreshed = Promise.resolve(window.refreshCartContents(response.clone ? response.clone() : response)); } catch (e) { refreshed = Promise.resolve(); }
    }
    return UK.withTimeout(refreshed.catch(function () {}), 5000).then(function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; });
    }).then(function (cart) {
      pulseBadge(cart ? cart.item_count : undefined);
      if (cart) UK.leadRender(cart);
      if (opts.silent) return;           /* samples page: the drawer opens later, once */
      UK.showAdded(cart, opts.panel || {});
    }).then(function () { if (UK.floating) UK.floating(); });
  };

  /* ---------------- add to cart ----------------
     items: [{id: variantId, quantity: n, properties: {}}]                  */
  UK.addToCart = function (items, opts) {
    opts = opts || {};
    if (opts.lead) {
      var props = UK.leadProps(opts.lead);
      items = items.map(function (i) { var c = {}; Object.keys(i).forEach(function (k) { c[k] = i[k]; }); c.properties = Object.assign({}, i.properties || {}, props); return c; });
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return UK.afterAdd(response, { button: opts.button, silent: opts.silent, panel: opts.panel });
    }).catch(function () {
      UK.toast('Something went wrong. Please try again.');
    });
  };

  UK.busy = function (btn, on, restore) {
    if (!btn) return;
    if (on) {
      btn.dataset.ukLabel = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span class="uk-spinner" aria-hidden="true">…</span><span class="visually-hidden">Adding</span>';
    } else {
      btn.disabled = false;
      btn.innerHTML = restore || btn.dataset.ukLabel || btn.innerHTML;
    }
  };

  /* ---------------- carousel: dots + arrows, user driven ---------------- */
  function initCarousel(root) {
    if (root.dataset.ukCarouselReady) return;
    root.dataset.ukCarouselReady = '1';
    var track = root.querySelector('[data-uk-track]');
    if (!track) return;
    var dotsWrap = root.querySelector('[data-uk-dots]');
    var prev = root.querySelector('[data-uk-prev]');
    var next = root.querySelector('[data-uk-next]');
    var slides = Array.prototype.slice.call(track.children);
    var dots = [];

    if (dotsWrap && slides.length > 1) {
      dotsWrap.innerHTML = '';
      slides.forEach(function (slide, i) {
        var pad = document.createElement('button');
        pad.type = 'button';
        pad.className = 'uk-dotpad';
        pad.setAttribute('aria-label', 'Go to item ' + (i + 1));
        var dot = document.createElement('span');
        dot.className = 'uk-dot';
        pad.appendChild(dot);
        pad.addEventListener('click', function () {
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(pad);
        dots.push(dot);
      });
    }

    function step(dir) {
      var w = slides[0] ? slides[0].getBoundingClientRect().width + 12 : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    function sync() {
      var i = 0;
      var best = Infinity;
      slides.forEach(function (slide, idx) {
        var d = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (d < best) { best = d; i = idx; }
      });
      dots.forEach(function (dot, idx) { dot.setAttribute('aria-current', idx === i ? 'true' : 'false'); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    track.addEventListener('scroll', function () {
      window.clearTimeout(track._ukT);
      track._ukT = window.setTimeout(sync, 60);
    });
    sync();
  }

  /* ---------------- video modal: nothing loads until tapped ------------- */
  function openVideo(source, type) {
    var modal = document.createElement('div');
    modal.className = 'uk-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    var media = type === 'file'
      ? '<video src="' + source + '" controls autoplay playsinline></video>'
      : '<iframe src="' + source + '" title="Video" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    modal.innerHTML =
      '<div class="uk-modal__inner">' +
        '<button class="uk-modal__close" type="button" aria-label="Close video">&times;</button>' +
        '<div class="uk-modal__frame">' + media + '</div>' +
      '</div>';
    function close() {
      modal.remove();
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('uk-modal__close')) close();
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    modal.querySelector('.uk-modal__close').focus();
  }
  UK.openVideo = openVideo;

  /* ---------------- Round 16: Shopify-native project gallery ----------------
     Filters (project + panel) built from the entries, sort = "show first" then order, #fireplace
     in the URL pre-selects a project, "Show more" past the limit, YouTube/Vimeo links become embeds. */
  function embedUrl(u) {
    var m;
    if ((m = /(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/))([\w-]{6,})/.exec(u))) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0';
    if ((m = /vimeo\.com\/(?:video\/)?(\d+)/.exec(u))) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
    return u;
  }
  function initPhotoGrids(scope) {
    (scope || document).querySelectorAll('[data-uk-photogrid]').forEach(function (root) {
      if (root.dataset.ukPhotogridReady) return;
      root.dataset.ukPhotogridReady = '1';
      var grid = root.querySelector('[data-uk-photo-list]'); if (!grid) return;
      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-uk-item]'));
      var limit = parseInt(root.dataset.ukLimit, 10) || 0, shown = limit;
      var sel = { project: '', range: '' };
      var count = root.querySelector('[data-uk-count]'), empty = root.querySelector('[data-uk-empty]'), more = root.querySelector('[data-uk-more]');
      /* video links pasted from YouTube/Vimeo → embeds */
      root.querySelectorAll('[data-uk-video][data-uk-video-type="url"]').forEach(function (b) { b.dataset.ukVideo = embedUrl(b.dataset.ukVideo); b.dataset.ukVideoType = 'embed'; });
      /* order: show-first photos, then by order number, then as entered */
      items.map(function (el, i) { return { el: el, f: el.dataset.ukFeatured === '1' ? 0 : 1, o: parseInt(el.dataset.ukOrder, 10) || 999, i: i }; })
        .sort(function (a, b) { return a.f - b.f || a.o - b.o || a.i - b.i; })
        .forEach(function (x) { grid.appendChild(x.el); });
      items = Array.prototype.slice.call(grid.querySelectorAll('[data-uk-item]'));
      function matches(el) {
        var p = (' ' + (el.dataset.ukProject || '') + ' ');
        if (sel.project && p.indexOf(' ' + sel.project + ' ') < 0) return false;
        if (sel.range && el.dataset.ukRange !== sel.range) return false;
        return true;
      }
      function apply() {
        var n = 0, visible = 0;
        items.forEach(function (el) {
          var ok = matches(el); if (ok) n++;
          var show = ok && (!limit || n <= shown);
          el.hidden = !show; if (show) visible++;
        });
        if (count) count.textContent = n ? (n + (n === 1 ? ' photo' : ' photos')) : '';
        if (empty) empty.hidden = n > 0;
        if (more) { more.hidden = !(limit && n > shown); more.textContent = 'Show more (' + Math.max(0, n - visible) + ' more)'; }
        root.querySelectorAll('[data-uk-filter]').forEach(function (b) { var on = (sel[b.dataset.ukFilter] || '') === (b.dataset.ukValue || ''); b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      }
      root.querySelectorAll('[data-uk-filter]').forEach(function (b) {
        b.addEventListener('click', function () { sel[b.dataset.ukFilter] = b.dataset.ukValue || ''; shown = limit; apply(); });
      });
      if (more) more.addEventListener('click', function () { shown += limit; apply(); });
      /* #fireplace, #media-wall … from the search shortcuts and the project chips */
      function fromHash() {
        var hash = (window.location.hash || '').replace('#', '').toLowerCase();
        if (hash && root.querySelector('[data-uk-filter="project"][data-uk-value="' + hash + '"]')) { sel.project = hash; shown = limit; return true; }
        return false;
      }
      fromHash();
      window.addEventListener('hashchange', function () { if (fromHash()) apply(); });
      apply();
    });
  }
  UK.embedUrl = embedUrl;

  /* ---------------- Round 20: North America bar ----------------
     Shopify tells the browser which country the visitor is in (/browsing_context_suggestions.json,
     the same call its own country picker uses). If it is one of the listed countries the bar
     from uk-settings moves to the very top of the page. Never a redirect; "×" and the button
     are remembered on the device; ?uk_region=US forces it for testing; bots never see it. */
  function initRegionBar() {
    var bar = document.querySelector('[data-uk-region-bar]');
    if (!bar || bar.dataset.ukRegionReady) return;
    bar.dataset.ukRegionReady = '1';
    if (window.Shopify && window.Shopify.designMode) return;
    if (/bot|crawl|spider|slurp|facebookexternalhit|bingpreview/i.test(navigator.userAgent)) return;
    var KEY = 'uk-region-bar';
    var list = String(bar.dataset.ukRegionCountries || 'US, CA, MX').toUpperCase().split(/[\s,]+/).filter(Boolean);
    function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    function show() { document.body.insertBefore(bar, document.body.firstChild); bar.hidden = false; }
    var close = bar.querySelector('[data-uk-region-close]');
    if (close) close.addEventListener('click', function () { remember('stay'); bar.hidden = true; });
    var go = bar.querySelector('[data-uk-region-go]');
    if (go) go.addEventListener('click', function () { remember('go'); });
    var force = '';
    try { force = (new URLSearchParams(location.search).get('uk_region') || '').toUpperCase(); } catch (e) {}
    if (force) { if (list.indexOf(force) > -1) show(); return; }
    try { if (localStorage.getItem(KEY)) return; } catch (e) {}
    if (!window.fetch) return;
    fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!c && d && d.suggestions && d.suggestions[0] && d.suggestions[0].parts && d.suggestions[0].parts.country) c = d.suggestions[0].parts.country.handle;
        if (c && list.indexOf(String(c).toUpperCase()) > -1) show();
      })
      .catch(function () {});
  }
  UK.initRegionBar = initRegionBar;

  function initVideoTriggers(scope) {
    (scope || document).querySelectorAll('[data-uk-video]').forEach(function (btn) {
      if (btn.dataset.ukVideoReady) return;
      btn.dataset.ukVideoReady = '1';
      btn.addEventListener('click', function () {
        openVideo(btn.dataset.ukVideo, btn.dataset.ukVideoType || 'embed');
      });
    });
  }

  /* ---------------- inline poster clips (play on tap only) -------------- */
  function initPosterClips(scope) {
    (scope || document).querySelectorAll('[data-uk-clip]').forEach(function (btn) {
      if (btn.dataset.ukClipReady) return;
      btn.dataset.ukClipReady = '1';
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-uk-clip-wrap]');
        var video = document.createElement('video');
        video.src = btn.dataset.ukClip;
        video.controls = true;
        video.playsInline = true;
        video.muted = true;
        video.style.width = '100%';
        video.style.aspectRatio = '4 / 5';
        video.style.objectFit = 'cover';
        wrap.innerHTML = '';
        wrap.appendChild(video);
        video.play();
      });
    });
  }

  /* ---------------- before / after ---------------- */
  function initBeforeAfter(scope) {
    (scope || document).querySelectorAll('[data-uk-ba]').forEach(function (root) {
      if (root.dataset.ukBaReady) return;
      root.dataset.ukBaReady = '1';
      var range = root.querySelector('input[type="range"]');
      var after = root.querySelector('.uk-ba__after');
      var handle = root.querySelector('.uk-ba__handle');
      if (!range || !after) return;
      function draw() {
        after.style.width = range.value + '%';
        if (handle) handle.style.left = range.value + '%';
      }
      range.addEventListener('input', draw);
      draw();
    });
  }

  /* ---------------- accordion ---------------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-uk-acc] .uk-acc__btn').forEach(function (btn) {
      if (btn.dataset.ukAccReady) return;
      btn.dataset.ukAccReady = '1';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = open;
      });
    });
  }

  /* ---------------- panel calculator ----------------
     data-uk-calc holds: { products: [{handle,title,variantId,price,coverage}],
                           waste: 8, tiers: [{min, price}] }               */
  function initCalculators(scope) {
    (scope || document).querySelectorAll('[data-uk-calc]').forEach(function (root) {
      if (root.dataset.ukCalcReady) return;
      root.dataset.ukCalcReady = '1';
      var cfg;
      try { cfg = JSON.parse(root.querySelector('[data-uk-calc-data]').textContent); } catch (e) { return; }
      if (!cfg.products || !cfg.products.length) return;

      var pick = root.querySelector('[data-uk-calc-product]');
      var picker = root.querySelector('[data-uk-picker]');
      var preview = root.querySelector('[data-uk-pick-preview]');
      var outPanels = root.querySelector('[data-uk-out-panels]');
      var outTotal = root.querySelector('[data-uk-out-total]');
      if (!outPanels || !outTotal) return;
      var outSqm = root.querySelector('[data-uk-out-sqm]');
      var outArea = root.querySelector('[data-uk-out-area]');
      var outUnit = root.querySelector('[data-uk-out-unit]');
      var outCoverage = root.querySelector('[data-uk-out-coverage]');
      var tilesEl = root.querySelector('[data-uk-calc-tiers]');
      var addBtn = root.querySelector('[data-uk-calc-add]');
      var summary = root.querySelector('[data-uk-calc-summary]');
      var bar = root.querySelector('[data-uk-calc-bar]');
      var barBtn = root.querySelector('[data-uk-calc-bar-add]');
      var rowsEl = root.querySelector('[data-uk-rows]');
      var tpl = root.querySelector('[data-uk-row-tpl]');
      var legacyW = root.querySelector('[data-uk-calc-w]'), legacyH = root.querySelector('[data-uk-calc-h]');
      var rules = UK.parseRules(String(cfg.rules || '').trim() ? cfg.rules : UK.globalRulesText());
      var defaultCoverage = parseFloat(cfg.defaultCoverage) || 0.68;
      var waste = 1 + (parseFloat(cfg.waste) || 8) / 100;
      var state = { panels: 0, product: cfg.products[0], touched: false, inBasket: 0 };
      var storeKey = 'uk-project-rows';
      var remember = !rowsEl || rowsEl.dataset.ukRemember !== 'false';

      /* per product: coverage (metafield → rule → section default) and tiers (rule → flat) */
      function describe(product) {
        var rule = UK.ruleFor(rules, product.handle);
        var coverage = parseFloat(product.coverage) > 0 ? parseFloat(product.coverage) : (rule.coverage > 0 ? rule.coverage : defaultCoverage);
        return { coverage: coverage, unit: rule.unit || 'panel', tiers: UK.tiersFor(product.price, rule) };
      }
      function drawTiles(d, qty) {
        if (!tilesEl) return;
        tilesEl.innerHTML = '';
        d.tiers.forEach(function (t) {
          var div = document.createElement('div');
          var range = t.max === Infinity ? t.min + '+' : (t.min === t.max ? String(t.min) : t.min + '–' + t.max);
          div.innerHTML = '<b></b><span></span>';
          div.querySelector('b').textContent = UK.money0(t.price);
          div.querySelector('span').textContent = range + ' ' + UK.unitWord(d.unit, t.max === Infinity ? 2 : t.max);
          div.setAttribute('aria-pressed', String(qty > 0 && qty >= t.min && qty <= t.max));
          div.setAttribute('data-uk-calc-tier', t.min);
          tilesEl.appendChild(div);
        });
      }
      function m2(n) { return (Math.round(n * 100) / 100) + ' m\u00b2'; }
      function dimText(m) {
        var u = dims ? dims.unit() : 'm';
        if (u === 'cm') return String(Math.round(m * 100));
        if (u === 'ft') { var tot = m / 0.0254, ft = Math.floor(tot / 12 + 1e-9), inch = Math.round(tot - ft * 12); if (inch === 12) { ft++; inch = 0; } return ft + ' ft' + (inch ? ' ' + inch + ' in' : ''); }
        return String(Math.round(m * 100) / 100);
      }

      /* ----- areas, each with its own openings ----- */
      var dims = null;
      var otpl = root.querySelector('[data-uk-opening-tpl]');
      function rows() { return rowsEl ? Array.prototype.slice.call(rowsEl.querySelectorAll('[data-uk-row]')) : []; }
      function dimsOf(el) { var ds = el.querySelectorAll(':scope > .uk-row__dims [data-uk-dim]'); return { w: dims ? dims.getEl(ds[0]) : 0, h: dims ? dims.getEl(ds[1]) : 0 }; }
      function openingData(o) { var d = dimsOf(o); return { label: (o.querySelector('[data-uk-row-label]') || {}).value || '', w: d.w, h: d.h }; }
      function rowData(r) {
        var d = dimsOf(r);
        return { type: 'wall', label: (r.querySelector(':scope > [data-uk-row-label]') || {}).value || '', w: d.w, h: d.h, corner: !!(r.querySelector('[data-uk-row-corner]') || {}).checked,
          openings: Array.prototype.slice.call(r.querySelectorAll('[data-uk-opening]')).map(openingData) };
      }
      function fillDims(el, data) { var ds = el.querySelectorAll(':scope > .uk-row__dims [data-uk-dim]'); if (data) { ds[0].dataset.ukMetres = data.w || ''; ds[1].dataset.ukMetres = data.h || ''; } }
      function addOpening(areaRow, data) {
        if (!otpl) return null;
        var host = areaRow.querySelector('[data-uk-openings]'); if (!host) return null;
        var o = otpl.content.firstElementChild.cloneNode(true);
        if (data && data.label) o.querySelector('[data-uk-row-label]').value = data.label;
        fillDims(o, data);
        host.appendChild(o);
        if (dims) dims.rescan();
        return o;
      }
      function addRow(type, data) {
        if (!rowsEl || !tpl) return null;
        var r = tpl.content.firstElementChild.cloneNode(true);
        if (data && data.label) r.querySelector(':scope > [data-uk-row-label]').value = data.label;
        fillDims(r, data);
        if (data && data.corner) r.querySelector('[data-uk-row-corner]').checked = true;
        rowsEl.appendChild(r);
        if (dims) dims.rescan();
        (data && data.openings || []).forEach(function (od) { addOpening(r, od); });
        return r;
      }
      function save() {
        if (!remember || !rowsEl) return;
        try { localStorage.setItem(storeKey, JSON.stringify(rows().map(rowData))); } catch (e) {}
      }
      function load() {
        if (!rowsEl) return false;
        var saved = null;
        if (remember) { try { saved = JSON.parse(localStorage.getItem(storeKey) || 'null'); } catch (e) { saved = null; } }
        if (Array.isArray(saved) && saved.length) {
          /* older saves kept openings as top-level rows: fold them into the area before them */
          var lastArea = null;
          saved.forEach(function (d) {
            if (d.type === 'opening') { if (lastArea) (lastArea.openings = lastArea.openings || []).push(d); return; }
            lastArea = d;
          });
          /* 30 Sep 2026 — until today the calculator opened on a made-up 3 × 2.4 m wall, and any
             click saved it as if the visitor had typed it. One unnamed 3 × 2.4 m area with no
             openings or corner is that old default, not a measurement: start empty instead. */
          var walls = saved.filter(function (d) { return d.type !== 'opening'; });
          var oldDefault = walls.length === 1 && Number(walls[0].w) === 3 && Number(walls[0].h) === 2.4 && !walls[0].label && !walls[0].corner && !(walls[0].openings || []).length;
          if (!oldDefault) {
            walls.forEach(function (d) { addRow('wall', d); });
            if (rows().length) return true;
          }
        }
        addRow('wall');   /* empty: no size until the visitor gives one */
        return false;
      }
      function areas() {
        var walls = 0, openings = 0, corner = false, per = [];
        if (rowsEl) {
          rows().forEach(function (r, idx) {
            var d = rowData(r); var gross = d.w * d.h; var less = 0;
            var ops = Array.prototype.slice.call(r.querySelectorAll('[data-uk-opening]')).map(function (o) { var od = openingData(o); var oa = od.w * od.h; less += oa; return { el: o, data: od, area: oa }; });
            if (d.corner && gross > 0) corner = true;
            walls += gross; openings += Math.min(less, gross);
            per.push({ row: r, data: d, gross: gross, less: Math.min(less, gross), net: Math.max(0, gross - less), openings: ops, index: idx });
          });
        } else if (legacyW && legacyH) {
          walls = (parseFloat(legacyW.value) || 0) * (parseFloat(legacyH.value) || 0);
        }
        return { walls: walls, openings: openings, net: Math.max(0, walls - openings), corner: corner, per: per };
      }
      var project = root.querySelector('[data-uk-project]');
      state.note = '';

      /* ----- the numbers ----- */
      function recalc() {
        var product = cfg.products[0];
        if (pick && pick.value) product = cfg.products.filter(function (p) { return String(p.variantId) === String(pick.value); })[0] || product;
        state.product = product;
        var d = describe(product);
        var a = areas();
        var area = a.net;
        /* each area is rounded up on its own (ceil((net area ÷ coverage) × 1.08)), then the areas are summed —
           so the per-area counts always add up to the total */
        var panels = a.per.length ? a.per.reduce(function (n, x) { return n + (x.net > 0 ? Math.ceil((x.net / d.coverage) * waste) : 0); }, 0) : (area > 0 ? Math.ceil((area / d.coverage) * waste) : 0);
        state.panels = panels;
        var each = UK.priceAt(d.tiers, panels);
        var total = panels * each;
        var sqm = panels > 0 ? total / (panels * d.coverage) : 0;
        var word = UK.unitWord(d.unit, panels || 2);

        var lines = [], noteParts = [];
        a.per.forEach(function (x) {
          var out = x.row.querySelector(':scope > [data-uk-row-out]'); var done = x.gross > 0;
          x.row.classList.toggle('is-done', done);
          var name = x.data.label || ('Area ' + (x.index + 1));
          var n = done ? Math.ceil((Math.max(0, x.net) / d.coverage) * waste) : 0;   /* net of its openings, rounded up — these lines add up to the total */
          if (out) {
            out.textContent = done ? (x.data.label ? x.data.label + ' · ' : '') + dimText(x.data.w) + ' × ' + dimText(x.data.h) + (dims && dims.unit() === 'ft' ? '' : ' ' + (dims ? dims.unit() : 'm')) + ' ≈ ' + n + ' ' + UK.unitWord(d.unit, n) + ' ✓' : 'Enter the width and height';
            out.classList.toggle('is-hint', !done);   /* no count for an area until it has both sizes */
          }
          if (done) { lines.push({ text: name, n: n }); noteParts.push(name + ' ' + n); }
          x.openings.forEach(function (o) {
            var oo = o.el.querySelector('[data-uk-row-out]'); var od = o.area > 0;
            o.el.classList.toggle('is-done', od);
            var oname = o.data.label || 'opening';
            if (oo) oo.textContent = od ? (o.data.label ? o.data.label + ' · ' : '') + dimText(o.data.w) + ' × ' + dimText(o.data.h) + (dims && dims.unit() === 'ft' ? '' : ' ' + (dims ? dims.unit() : 'm')) + ' − ' + m2(o.area) : '';
            if (od) { lines.push({ text: 'Less: ' + oname, area: o.area, less: true }); noteParts.push('less ' + oname + ' ' + m2(o.area)); }
          });
        });
        state.note = noteParts.join(', ');
        if (project) {
          project.innerHTML = '';
          lines.forEach(function (l) {
            var li = document.createElement('li'); if (l.less) li.className = 'uk-project__less';
            var sp = document.createElement('span'); sp.textContent = l.text;
            var b = document.createElement('b'); b.textContent = l.less ? '− ' + m2(l.area) : l.n + ' ' + UK.unitWord(d.unit, l.n);
            li.appendChild(sp); li.appendChild(b); project.appendChild(li);
          });
          project.hidden = !lines.length;
        }
        if (summary) {
          if (a.walls > 0) {
            summary.hidden = false;
            summary.textContent = 'Walls ' + m2(a.walls) + (a.openings > 0 ? ' − openings ' + m2(a.openings) + ' = ' + m2(a.net) : '') + ' → ' + panels + ' ' + word + ' (incl. ' + Math.round((waste - 1) * 100) + '% for cuts)';
          } else if (rowsEl) {   /* nothing measured yet: say what to do, never a number */
            summary.hidden = false; summary.textContent = 'Add your wall size to see how many ' + word;
          } else { summary.hidden = true; summary.textContent = ''; }
          summary.classList.toggle('is-hint', !(a.walls > 0));
        }
        if (outArea) outArea.textContent = area > 0 ? area.toFixed(2) + ' m²' : '—';
        outPanels.textContent = panels > 0 ? String(panels) : '—';
        if (outUnit) outUnit.textContent = word;
        outTotal.textContent = panels > 0 ? UK.money(total) : '—';
        if (outSqm) outSqm.textContent = panels > 0 ? UK.money(sqm) + ' / m²' : '—';
        if (outCoverage) outCoverage.textContent = d.coverage.toFixed(2) + ' m² per ' + UK.unitWord(d.unit, 1) + ' used';
        drawTiles(d, panels);
        if (addBtn) {
          addBtn.disabled = panels < 1;
          var tplText = (state.inBasket ? addBtn.dataset.ukUpdateLabel : addBtn.dataset.ukAddLabel) || 'Add [n] panels to basket';
          if (!addBtn.dataset.ukBusyNow) addBtn.textContent = tplText.replace('[n]', panels > 0 ? String(panels) : '').replace('panels', word).replace(/\s+/g, ' ').trim();
        }
        /* phone summary bar mirrors the answer: "12 panels · £839.88 · Add to basket" */
        if (bar) {
          var bc = bar.querySelector('[data-uk-bar-count]'), bu = bar.querySelector('[data-uk-bar-unit]'), bt = bar.querySelector('[data-uk-bar-total]'), bcol = bar.querySelector('[data-uk-bar-colour]');
          if (bc) bc.textContent = panels > 0 ? String(panels) : '\u2014';
          if (bu) bu.textContent = word;
          if (bt) bt.textContent = panels > 0 ? UK.money(total) : '\u2014';
          if (bcol) bcol.textContent = product.name ? product.name + ' \u00b7 ' + (product.colour || '') : '';
          if (barBtn) { barBtn.disabled = panels < 1; barBtn.textContent = state.inBasket && state.inBasket !== panels ? 'Update to ' + panels : 'Add to basket'; }
        }
        if (preview) {
          var pb = picker && picker.querySelector('[data-uk-pick-variant="' + product.variantId + '"]');
          var img = preview.querySelector('[data-uk-pick-preview-img]');
          if (img) { var src = pb && pb.dataset.ukPickImage; img.hidden = !src; if (src && img.getAttribute('src') !== src) img.src = src; }
          var nm = preview.querySelector('[data-uk-pick-preview-name]');
          if (nm) nm.textContent = product.name ? product.name + ' · ' + (product.colour || '') : product.title;
          var pr = preview.querySelector('[data-uk-pick-preview-price]');
          if (pr) { var eachNow = UK.priceAt(d.tiers, Math.max(1, panels)); var tierNow = null; d.tiers.forEach(function (t) { if (Math.max(1, panels) >= t.min) tierNow = t; }); pr.textContent = UK.money(eachNow) + ' per ' + UK.unitWord(d.unit, 1) + (tierNow && tierNow.min > 1 ? ' \u00b7 ' + tierNow.min + '+ price' : ''); }
        }
        state.hasCorner = !!a.corner;
        root.querySelectorAll('[data-uk-calc-addon="corner"]').forEach(function (r) { r.hidden = !a.corner || r.dataset.ukNoVariant === '1'; });
        var box = root.querySelector('[data-uk-calc-addons]');
        if (box) box.hidden = !(panels > 0) || !Array.prototype.some.call(box.querySelectorAll('[data-uk-calc-addon]'), function (r) { return !r.hidden; });
        /* product page: the project calculator writes back up to the buy box */
        if (cfg.locked && state.touched && panels > 0) {
          var qtyInput = document.querySelector('[data-uk-product] [data-uk-qty]');
          if (qtyInput && String(qtyInput.value) !== String(panels)) { qtyInput.value = panels; qtyInput.dispatchEvent(new Event('input', { bubbles: true })); }
        }
      }
      function onRowsChange() { state.touched = true; save(); recalc(); }
      function focusFirst(el) { var f = el && el.querySelector('[data-uk-row-label]'); if (f) f.focus(); }

      if (rowsEl && tpl) {
        load();
        dims = UK.initDims(root, onRowsChange);
        rowsEl.addEventListener('input', function (e) { if (e.target.matches('[data-uk-row-label]')) { save(); recalc(); } });
        /* Enter / the keyboard's Next: name → width → height → the next thing to do */
        rowsEl.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return;
          var inp = e.target; if (!inp.matches('input')) return;
          e.preventDefault();
          var box = inp.closest('[data-uk-opening]') || inp.closest('[data-uk-row]');
          var fields = Array.prototype.slice.call(box.querySelectorAll(':scope > [data-uk-row-label], :scope > .uk-row__dims input')).filter(function (f) { return !f.hidden && f.offsetParent !== null; });
          var at = fields.indexOf(inp);
          if (at > -1 && at < fields.length - 1) { fields[at + 1].focus(); if (fields[at + 1].select) fields[at + 1].select(); return; }
          var add = root.querySelector('[data-uk-row-add="wall"]'); if (add) add.focus();
        });
        rowsEl.addEventListener('change', function (e) { if (e.target.matches('[data-uk-row-corner]')) onRowsChange(); });
        rowsEl.addEventListener('click', function (e) {
          var oa = e.target.closest('[data-uk-opening-add]');
          if (oa) { var o = addOpening(oa.closest('[data-uk-row]')); onRowsChange(); if (o) { var w0 = o.querySelector('[data-uk-metric]:not([hidden]), [data-uk-ft]:not([hidden])'); if (w0) w0.focus(); } return; }
          var rm = e.target.closest('[data-uk-row-remove]'); if (!rm) return;
          var box = rm.closest('[data-uk-opening]') || rm.closest('[data-uk-row]');
          box.remove();
          if (!rows().length) addRow('wall');
          onRowsChange();
        });
        root.querySelectorAll('[data-uk-row-add]').forEach(function (b) {
          b.addEventListener('click', function () {
            var r = addRow('wall');
            state.touched = true; save(); recalc();
            focusFirst(r);
          });
        });
      } else {
        dims = UK.initDims ? UK.initDims(root, recalc) : null;
        if (!dims && legacyW && legacyH) [legacyW, legacyH].forEach(function (el) { el.addEventListener('input', recalc); el.addEventListener('change', recalc); });
      }
      if (pick && pick.tagName === 'SELECT') pick.addEventListener('change', recalc);

      /* ----- visual picker: range chips → colour swatches → chosen swatch large ----- */
      function byId(id) { return cfg.products.filter(function (p) { return String(p.variantId) === String(id); })[0]; }
      function setVariant(id, o) {
        o = o || {};
        var product = byId(id);
        if (!product || !pick) return;
        pick.value = String(id);
        state.product = product;
        if (remember) { try { localStorage.setItem(storeKey + '-variant', String(id)); } catch (e) {} }
        if (picker) {
          picker.querySelectorAll('[data-uk-pick-variant]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.ukPickVariant === String(id))); });
          picker.querySelectorAll('[data-uk-pick-range]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.ukPickRange === product.handle)); });
          picker.querySelectorAll('[data-uk-pick-colours]').forEach(function (c) { c.hidden = c.dataset.ukPickColours !== product.handle; });
          /* Round 17: material tabs (Stone / Brick / Concrete) — the chosen product's material is
             pressed and only that material's range chips show */
          var mat = product.material || '';
          picker.querySelectorAll('[data-uk-pick-material]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.ukPickMaterial === mat)); });
          if (picker.querySelector('[data-uk-pick-material]')) picker.querySelectorAll('[data-uk-pick-range][data-uk-material]').forEach(function (b) { b.hidden = b.dataset.ukMaterial !== mat; });
        }
        rematchAddons();
        syncBasket();
        /* product page: the calculator's colour is the buy box's colour, both ways */
        if (o.toBuyBox && cfg.locked) {
          var sw = document.querySelector('[data-uk-swatch="' + id + '"]');
          if (sw && sw.getAttribute('aria-pressed') !== 'true') sw.click();
        }
      }
      if (picker) {
        picker.addEventListener('click', function (e) {
          var m = e.target.closest('[data-uk-pick-material]');
          if (m) { var firstM = cfg.products.filter(function (p) { return (p.material || '') === m.dataset.ukPickMaterial; })[0]; if (firstM) { setVariant(firstM.variantId); var rr = picker.querySelector('[data-uk-pick-ranges]'); if (rr) rr.scrollLeft = 0; } return; }
          var r = e.target.closest('[data-uk-pick-range]');
          if (r) { var first = cfg.products.filter(function (p) { return p.handle === r.dataset.ukPickRange; })[0]; if (first) setVariant(first.variantId); return; }
          var c = e.target.closest('[data-uk-pick-variant]');
          if (c) setVariant(c.dataset.ukPickVariant, { toBuyBox: true });
        });
        document.addEventListener('uk:variant', function (e) {
          var id = e.detail && e.detail.id;
          if (id && byId(id) && String(pick.value) !== String(id)) setVariant(id);
        });
      }

      /* ----- finishes: colour-matched ticks, straight into the basket ----- */
      var addonRows = Array.prototype.slice.call(root.querySelectorAll('[data-uk-calc-addon]'));
      var addonBox = root.querySelector('[data-uk-calc-addons]');
      if (addonBox && addonBox.tagName === 'DETAILS' && window.matchMedia('(min-width:900px)').matches) addonBox.open = true;
      var addonTotal = root.querySelector('[data-uk-calc-addons] [data-uk-addon-total]');
      if (addonTotal) addonTotal.dataset.ukEmpty = addonTotal.textContent;
      var addonData = {};
      (cfg.addons || []).forEach(function (a) { addonData[a.handle] = a; });
      var aliases = parseAliases(cfg.aliases);
      var basketLines = {};
      function colourKeys(title) { var k = normColour(title); return [k].concat(aliases[k] || []); }
      function matchVariant(addon, colourTitle) {
        var keys = colourKeys(colourTitle || '');
        var list = (addon && addon.variants) || [];
        var mapped = UK.mapVariant(state.product.handle, colourTitle, addon && (addon.key || UK.roleFor(addon.handle)));
        if (mapped) { var hit = list.filter(function (v) { return v.id === mapped; })[0]; if (hit) return hit; }
        if (list.length === 1 && /default title/i.test(list[0].title)) return list[0];
        return list.filter(function (v) { var t = normColour(v.title); return keys.some(function (k) { return k && t.indexOf(k) > -1; }); })[0] || null;
      }
      function rowState(row, text, isError) {
        var st = row.querySelector('[data-uk-addon-state]'); if (!st) return;
        st.hidden = !text; st.textContent = text || ''; st.classList.toggle('is-error', !!isError);
      }
      function rematchAddons() {
        addonRows.forEach(function (row) {
          var v = matchVariant(addonData[row.dataset.ukAddonHandle], state.product.colour || '');
          var title = row.querySelector('[data-uk-addon-title]'), price = row.querySelector('[data-uk-addon-price]');
          if (!v) {   /* no variant in this colour: hide the row rather than offer the wrong one */
            row.dataset.ukVariant = ''; row.dataset.ukNoVariant = '1'; row.hidden = true;
            var inp = row.querySelector('input'); if (inp) inp.checked = false;
            return;
          }
          row.dataset.ukNoVariant = '';
          row.hidden = row.dataset.ukNeedsCorner === '1' && !state.hasCorner;
          row.dataset.ukVariant = v.id;
          if (title) title.textContent = row.dataset.ukLabel + ' · ' + (state.product.colour || '');
          if (price) price.textContent = UK.money(v.price);
        });
      }
      function fetchCart() {
        return UK.withTimeout(fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }), 6000).then(function (c) { return c || { items: [] }; }).catch(function () { return { items: [] }; });
      }
      function syncAddons(cart) {
        basketLines = {};
        var count = 0, sum = 0, ids = {};
        addonRows.forEach(function (row) { ((addonData[row.dataset.ukAddonHandle] || {}).variants || []).forEach(function (v) { ids[v.id] = true; }); });
        (cart.items || []).forEach(function (line) { basketLines[line.variant_id] = line; if (ids[line.variant_id]) { count += line.quantity; sum += line.final_line_price; } });
        addonRows.forEach(function (row) {
          var vid = Number(row.dataset.ukVariant), input = row.querySelector('input');
          var inBasket = !!(vid && basketLines[vid]);
          input.checked = inBasket;
          if (inBasket) rowState(row, 'Added ✓ · in your basket'); else if (!row.classList.contains('has-error')) rowState(row, '');
        });
        if (addonTotal) addonTotal.textContent = count ? count + (count === 1 ? ' extra' : ' extras') + ' in your basket · ' + UK.money(sum) : addonTotal.dataset.ukEmpty;
        var mine = basketLines[state.product.variantId];
        state.inBasket = mine ? mine.quantity : 0;
        UK.leadRender(cart);
        recalc();
      }
      function syncBasket() { return fetchCart().then(syncAddons); }
      function cartAdd(id, lead) { var item = { id: id, quantity: 1 }; if (lead) item.properties = UK.leadProps(lead); return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) }); }
      function cartChange(key, quantity) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity }) }); }
      addonRows.forEach(function (row) {
        var input = row.querySelector('input');
        input.addEventListener('change', function () {
          if (row.dataset.ukBusy) { input.checked = !input.checked; return; }
          var vid = Number(row.dataset.ukVariant);
          if (!vid) { input.checked = false; var go = row.querySelector('.uk-addon__go'); if (go) window.location.href = go.href; return; }
          row.dataset.ukBusy = '1'; row.classList.remove('has-error');
          var lead = ((addonData[row.dataset.ukAddonHandle] || {}).variants || []).filter(function (v) { return v.id === vid; }).map(function (v) { return v.lead; })[0];
          var flow;
          if (input.checked) {
            rowState(row, 'Adding…');
            flow = cartAdd(vid, lead).then(function (r) {
              if (!r.ok) return r.clone().json().catch(function () { return {}; }).then(function (d) { input.checked = false; row.classList.add('has-error'); rowState(row, (d && (d.description || d.message)) || 'Could not add this — please try again', true); });
              return UK.afterAdd(r, { silent: true });
            });
          } else {
            var line = basketLines[vid]; rowState(row, '');
            flow = line ? cartChange(line.key, 0).then(function (r) { if (typeof window.refreshCartContents === 'function') { try { window.refreshCartContents(r.clone()); } catch (e) {} } }) : Promise.resolve();
          }
          UK.withTimeout(flow.catch(function () { input.checked = false; row.classList.add('has-error'); rowState(row, 'Something went wrong — please try again', true); }), 8000)
            .then(syncBasket).then(function () { delete row.dataset.ukBusy; try { document.dispatchEvent(new CustomEvent('uk:cart')); } catch (e) {} });
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (state.panels < 1) return;
          state.touched = true;
          addBtn.dataset.ukBusyNow = '1';
          UK.busy(addBtn, true);
          UK.setPanels(state.product.variantId, state.panels, { button: addBtn, lead: state.product.lead, unit: describe(state.product).unit, props: state.note ? { 'Project': state.note } : null }).then(function () {
            addBtn.innerHTML = 'Added \u2713';
            setTimeout(function () { delete addBtn.dataset.ukBusyNow; addBtn.disabled = false; syncBasket(); try { document.dispatchEvent(new CustomEvent('uk:cart')); } catch (e) {} }, 1500);
          });
        });
      }
      if (barBtn && addBtn) barBtn.addEventListener('click', function () { addBtn.click(); });
      if (bar) bar.addEventListener('click', function (e) {
        if (e.target.closest('button')) return;
        var t = root.querySelector('[data-uk-calc-total]'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      document.addEventListener('uk:cart', function () { syncBasket(); });
      window.addEventListener('updated.ecomify.cart', function () { syncBasket(); });

      /* ----- restore a project from ?project= (the link in the quote email) ----- */
      var restored = null;
      try {
        var qp = new URLSearchParams(window.location.search).get('project');
        if (qp) restored = JSON.parse(decodeURIComponent(escape(atob(qp.replace(/-/g, '+').replace(/_/g, '/')))));
      } catch (e) { restored = null; }
      if (restored && rowsEl && tpl && Array.isArray(restored.areas)) {
        rows().forEach(function (r) { r.remove(); });
        restored.areas.forEach(function (a) { addRow('wall', { label: a.name || '', w: a.w, h: a.h, corner: !!a.corner, openings: (a.openings || []).map(function (o) { return { label: o.name || '', w: o.w, h: o.h }; }) }); });
        if (!rows().length) addRow('wall');
        state.touched = true; save();
        if (restored.variantId && byId(restored.variantId)) pick.value = String(restored.variantId);
        try { history.replaceState(null, '', window.location.pathname + window.location.hash); } catch (e) {}
      }

      /* ----- "Email me this quote": profile + 'Quote sent' event to Klaviyo (client API, public key) ----- */
      var quoteForm = root.querySelector('[data-uk-quote]');
      var quoteFormEl = quoteForm && (quoteForm.tagName === 'FORM' ? quoteForm : quoteForm.querySelector('form'));
      var kKey = (window.UK_SETTINGS && window.UK_SETTINGS.klaviyoKey) || '';
      /* no Klaviyo key: the email half goes, the block and its WhatsApp button stay */
      if (quoteForm && !kKey) quoteForm.classList.add('uk-qform--nokey');
      function projectPayload() {
        var a = areas(); var d = describe(state.product);
        var areasOut = a.per.map(function (x) {
          return { name: x.data.label || ('Area ' + (x.index + 1)), w: x.data.w, h: x.data.h, corner: !!x.data.corner, panels: x.gross > 0 ? Math.ceil((x.gross / d.coverage) * waste) : 0,
            openings: x.openings.map(function (o) { return { name: o.data.label || 'opening', w: o.data.w, h: o.data.h }; }) };
        });
        var total = state.panels * UK.priceAt(d.tiers, state.panels);
        var compact = { areas: areasOut.map(function (x) { return { name: x.name, w: x.w, h: x.h, corner: x.corner, openings: x.openings }; }), variantId: state.product.variantId };
        var token = btoa(unescape(encodeURIComponent(JSON.stringify(compact)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        var restoreUrl = window.location.origin + (cfg.locked ? window.location.pathname : '/') + '?project=' + token + '#calculator';
        return {
          areas: areasOut, summary: state.note, panels: state.panels, unit: UK.unitWord(d.unit, state.panels),
          product: state.product.name || state.product.title, colour: state.product.colour || '', variant_id: state.product.variantId,
          price_each: UK.money(UK.priceAt(d.tiers, state.panels)), total: UK.money(total), total_pence: total,
          measure_unit: dims ? dims.unit() : 'm', restore_url: restoreUrl, samples_url: window.location.origin + '/collections/samples', product_url: window.location.origin + '/products/' + state.product.handle
        };
      }
      var emailOk = function (v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(v || '').trim()); };
      /* send profile + "Quote sent" event to Klaviyo; channel = 'email' | 'whatsapp' */
      function sendQuote(email, channel) {
        var payload = projectPayload(); payload.channel = channel;
        var headers = { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' };
        var profile = { data: { type: 'profile', attributes: { email: email, properties: {
          last_quote_summary: payload.summary, last_quote_panels: payload.panels, last_quote_product: payload.product + (payload.colour ? ' · ' + payload.colour : ''),
          last_quote_total: payload.total, last_quote_url: payload.restore_url, last_quote_channel: channel, last_quote_at: new Date().toISOString() } } } };
        var event = { data: { type: 'event', attributes: { properties: payload, metric: { data: { type: 'metric', attributes: { name: 'Quote sent' } } }, profile: { data: { type: 'profile', attributes: { email: email } } }, unique_id: 'quote-' + Date.now() } } };
        var stop = new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, 8000); });
        return Promise.race([Promise.all([
          fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(kKey), { method: 'POST', headers: headers, body: JSON.stringify(profile) }),
          fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(kKey), { method: 'POST', headers: headers, body: JSON.stringify(event) })
        ]), stop]).then(function (rs) {
          var bad = rs.filter(function (r) { return !r.ok; })[0];
          if (bad) throw new Error('HTTP ' + bad.status);
          UK.log('quote sent to Klaviyo for ' + email + ' via ' + channel);
        });
      }
      /* the WhatsApp text: areas, counts, colour, total and the link that restores the project */
      function whatsappText() {
        var p = projectPayload();
        var lines = ['Hi Tritan BP, please send me this quote:'];
        p.areas.forEach(function (a) { lines.push('- ' + a.name + ': ' + a.w + ' x ' + a.h + ' ' + p.measure_unit + ' = ' + a.panels + ' ' + UK.unitWord(describe(state.product).unit, a.panels)); a.openings.forEach(function (o) { lines.push('  less ' + o.name + ' ' + o.w + ' x ' + o.h + ' ' + p.measure_unit); }); });
        lines.push('Colour: ' + p.product + (p.colour ? ' \u00b7 ' + p.colour : ''));
        lines.push('Total: ' + p.panels + ' ' + p.unit + ' \u00b7 ' + p.total + ' (' + p.price_each + ' each)');
        lines.push('Bring it back: ' + p.restore_url);
        return lines.join('\n');
      }
      if (quoteForm) {
        var qEmail = quoteForm.querySelector('[data-uk-quote-email]'), qStatus = quoteForm.querySelector('[data-uk-quote-status]');
        var say = function (t, bad) { if (!qStatus) return; qStatus.hidden = !t; qStatus.textContent = t || ''; qStatus.classList.toggle('is-error', !!bad); };
        /* validate on blur and submit only — never while typing */
        if (qEmail) {
          qEmail.addEventListener('blur', function () { if (qEmail.value.trim() && !emailOk(qEmail.value)) say('Please check the email address.', true); else if (qStatus && qStatus.classList.contains('is-error')) say(''); });
          qEmail.addEventListener('input', function () { if (qStatus && qStatus.classList.contains('is-error')) say(''); });
        }
        var waBtn = quoteForm.querySelector('[data-uk-quote-wa]');
        if (waBtn) waBtn.addEventListener('click', function () {
          if (state.panels < 1) { say('Add at least one area first.', true); return; }
          var num = waBtn.dataset.ukWa || '447441920001';
          var url = 'https://wa.me/' + num + '?text=' + encodeURIComponent(whatsappText());
          var email = qEmail ? qEmail.value.trim() : '';
          if (email && emailOk(email) && kKey) { sendQuote(email, 'whatsapp').catch(function (e) { UK.log('whatsapp quote event failed: ' + (e && e.message)); }); }
          say('Opening WhatsApp with your quote\u2026');
          var w = null; try { w = window.open(url, '_blank'); if (w) w.opener = null; } catch (e) { w = null; }
          if (!w) window.location.href = url;
        });
      }
      if (quoteFormEl && kKey) quoteFormEl.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailEl = quoteForm.querySelector('[data-uk-quote-email]'), status = quoteForm.querySelector('[data-uk-quote-status]'), btn = quoteForm.querySelector('[data-uk-quote-send]');
        var email = (emailEl.value || '').trim();
        function say(t, bad) { if (!status) return; status.hidden = false; status.textContent = t; status.classList.toggle('is-error', !!bad); }
        if (!emailOk(email)) { say('Please enter a valid email address.', true); emailEl.focus(); return; }
        if (state.panels < 1) { say('Add at least one area first.', true); return; }
        var label = btn.dataset.ukLabel || btn.textContent; btn.dataset.ukLabel = label; UK.busy(btn, true);
        var sent = false;
        sendQuote(email, 'email').then(function () {
          sent = true;
          say('Sent \u2713 \u2014 check your inbox for the quote and a link that brings this project back.');
        }).catch(function (e) {
          say('Something went wrong \u2014 try again, or WhatsApp us the measurements.', true);
          UK.log('quote failed: ' + (e && e.message));
        }).then(function () {
          UK.busy(btn, false, label);
          /* the button itself says it worked, in green, and stays that way until the address is changed */
          if (sent) { btn.textContent = 'Quote sent \u2713'; btn.classList.add('is-sent'); btn.disabled = true; btn.setAttribute('aria-live', 'polite'); }
        });
      });
      if (quoteFormEl && kKey) { var qEmailReset = quoteForm.querySelector('[data-uk-quote-email]'), qSend = quoteForm.querySelector('[data-uk-quote-send]');
        if (qEmailReset && qSend) qEmailReset.addEventListener('input', function () { if (qSend.classList.contains('is-sent')) { qSend.classList.remove('is-sent'); qSend.disabled = false; qSend.textContent = qSend.dataset.ukLabel || 'Email me this quote'; } }); }

      var rememberedVariant = null;
      if (remember && !restored) { try { rememberedVariant = localStorage.getItem(storeKey + '-variant'); } catch (e) {} }
      if (rememberedVariant && byId(rememberedVariant)) pick.value = String(rememberedVariant);
      /* Round 14c: always expanded, every screen size — the field and both buttons are on screen with no tap.
         (A collapsed line on phones read as a heading, not a control.) The summary is a plain heading. */
      if (quoteForm && quoteForm.tagName === 'DETAILS') {
        quoteForm.open = true;
        var qSummary = quoteForm.querySelector('summary');
        if (qSummary) qSummary.addEventListener('click', function (e) { e.preventDefault(); quoteForm.open = true; });
        quoteForm.addEventListener('toggle', function () { if (!quoteForm.open) quoteForm.open = true; });
      }
      if (pick && pick.value && byId(pick.value)) setVariant(pick.value); else { rematchAddons(); syncBasket(); }
    });
  }

  /* ---------------- samples hub: pick up to N ---------------- */
  function initSampleHubs(scope) {
    (scope || document).querySelectorAll('[data-uk-samples]').forEach(function (root) {
      if (root.dataset.ukSamplesReady) return;
      root.dataset.ukSamplesReady = '1';
      var max = parseInt(root.dataset.ukSamples, 10) || Infinity;
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-uk-sample]'));
      var count = root.querySelector('[data-uk-sample-count]');
      var total = root.querySelector('[data-uk-sample-total]');
      var addBtn = root.querySelector('[data-uk-sample-add]');

      function selected() {
        return buttons.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
      }
      function sync() {
        var sel = selected();
        if (count) count.textContent = sel.length + (max === Infinity ? ' chosen' : ' of ' + max + ' chosen');
        if (total) {
          total.textContent = sel.reduce(function (sum, b) {
            return sum + Number(b.dataset.ukPrice || 0);
          }, 0) ? UK.money(sel.reduce(function (s, b) { return s + Number(b.dataset.ukPrice || 0); }, 0)) : UK.money(0);
        }
        if (addBtn) addBtn.disabled = sel.length === 0;
        buttons.forEach(function (b) {
          var on = b.getAttribute('aria-pressed') === 'true';
          b.disabled = !on && sel.length >= max;
        });
      }
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          var on = b.getAttribute('aria-pressed') === 'true';
          if (!on && selected().length >= max) return;
          b.setAttribute('aria-pressed', String(!on));
          sync();
        });
      });
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var items = selected().map(function (b) {
            return { id: Number(b.dataset.ukVariant), quantity: 1 };
          });
          if (!items.length) return;
          var label = addBtn.innerHTML;
          UK.busy(addBtn, true);
          UK.addToCart(items, { button: addBtn }).then(function () { setTimeout(function () { UK.busy(addBtn, false, label); }, 2000); });
        });
      }
      sync();
    });
  }

  /* ---------------- product page ----------------
     gallery ordering + swatch switching, price tiers, mini calculator, colour-matched add-ons */
  function normColour(t) { return UK.normColour(t); }

  function parseAliases(text) {
    var map = {};
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var m = line.split('=');
      if (m.length < 2) return;
      map[normColour(m[0])] = m.slice(1).join('=').split(',').map(function (x) { return normColour(x); }).filter(Boolean);
    });
    return map;
  }
  /* image type from file name / alt: 0 installed wall · 1 single panel · 2 in-scale · 3 close-up · 4 other */
  function imageType(probe) {
    var p = probe.toLowerCase();
    if (/tongue|groove|close-?up|closeup|texture/.test(p)) return 3;
    if (/measur|dimension|size|scale|side|depth/.test(p)) return 2;
    if (/main|front|single|panel-finished|casepack|case-pack|pack/.test(p)) return 1;
    if (/install|room|wall|greenhouse|lifestyle|garden|kitchen|lounge|fireplace|bar|exterior|house|home/.test(p)) return 0;
    return 4;
  }

  function initProduct(scope) {
    (scope || document).querySelectorAll('[data-uk-product]').forEach(function (root) {
      if (root.dataset.ukProductReady) return;
      root.dataset.ukProductReady = '1';
      var dataEl = root.querySelector('[data-uk-product-data]') ||
        (root.closest('section') || document).querySelector('[data-uk-product-data]');
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var variants = data.variants || [];
      var tiers = data.tiers || [];
      var coverage = data.coverage > 0 ? data.coverage : 0;
      var current = variants.filter(function (v) { return v.id === data.selected; })[0] || variants[0];
      if (!current) return;
      var rule = UK.ruleFor(String(data.rules || '').trim() ? UK.parseRules(data.rules) : UK.globalRules(), data.handle);
      var unit = (rule && rule.unit) || 'panel';
      if (rule && !(data.coverage > 0) && rule.coverage > 0) coverage = rule.coverage;
      if (rule && rule.offs.length) {
        var ruleTiers = UK.tiersFor(current.price, rule);
        tiers = ruleTiers.slice(1).map(function (t) { return { min: t.min, price: t.price }; });
        root.querySelectorAll('[data-uk-tier]').forEach(function (b, i) {
          var t = ruleTiers[i];
          if (!t) { b.hidden = true; return; }
          b.hidden = false;
          b.dataset.ukTier = t.min;
          if (t.max === Infinity) b.removeAttribute('data-uk-tier-max'); else b.dataset.ukTierMax = t.max;
          var q = b.querySelector('.uk-ladder__qty'), e = b.querySelector('.uk-ladder__each');
          if (q) q.textContent = t.max === Infinity ? t.min + '+' : t.min + '–' + t.max;
          if (e) e.textContent = UK.money0(t.price);
        });
      }

      var basketLines = {};
      var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-uk-swatch]'));
      var ladder = Array.prototype.slice.call(root.querySelectorAll('[data-uk-tier]'));
      var qtyInput = root.querySelector('[data-uk-qty]');
      var totalEl = root.querySelector('[data-uk-total]');
      var eachEl = root.querySelector('[data-uk-each]');
      var colourNames = Array.prototype.slice.call(root.querySelectorAll('[data-uk-colour-name]'));   /* title line + swatch label */
      var idInput = root.querySelector('[data-uk-variant-id]');
      root.querySelectorAll('[data-uk-colours-jump]').forEach(function (jump) {
        jump.addEventListener('click', function () {
          var sw = root.querySelector('.uk-swatches'); if (!sw) return;
          try { sw.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { sw.scrollIntoView(); }
          var on = sw.querySelector('[aria-pressed="true"]') || sw.querySelector('[data-uk-swatch]');
          if (on) { try { on.focus({ preventScroll: true }); } catch (e) {} }
        });
      });
      var atc = root.querySelector('[data-uk-atc]');
      var stickyPrice = document.querySelector('[data-uk-sticky-price]');
      var stickyColour = document.querySelector('[data-uk-sticky-colour]');
      var stickyBasket = document.querySelector('[data-uk-sticky-basket]');
      var leadText = root.querySelector('[data-uk-leadline-text]');
      var leadNote = root.querySelector('[data-uk-leadline-note]');
      var badgeEl = root.querySelector('[data-uk-badge]');
      /* lead time for the selected colour: stock decides, nothing is ever "sold out" */
      var amazonEl = root.querySelector('[data-uk-amazon]');
      function renderAmazon() {
        if (!amazonEl) return;
        var a = current.amazon || {};
        var n = Number(a.count) || 0;
        var ok = a.url && a.rating && n >= 5;   /* under five reviews the line stays hidden — not worth showing yet */
        amazonEl.hidden = !ok;
        if (!ok) return;
        amazonEl.href = a.url;
        var r = amazonEl.querySelector('[data-uk-amazon-rating]'), c = amazonEl.querySelector('[data-uk-amazon-count]'), w = amazonEl.querySelector('[data-uk-amazon-word]');
        if (r) r.textContent = (Number(a.rating) || 0).toFixed(1);
        if (c) c.textContent = String(n);
        if (w) w.textContent = n === 1 ? 'review' : 'reviews';
      }
      function renderLead() {
        renderAmazon();
        var st = current.state || 'quick';
        if (leadText && current.lead) { leadText.textContent = current.lead; leadText.classList.toggle('is-quick', st === 'quick'); leadText.classList.toggle('is-wait', st !== 'quick'); }
        if (leadNote && st !== 'preorder') leadNote.hidden = st === 'quick';
        /* 30 Sep 2026 — made-to-order colours carry their own expected dispatch date (uk-ship-badge mode 'dispatch'). */
        if (leadNote && st === 'made' && leadNote.dataset.ukMadeLine) leadNote.textContent = current.dispatch ? leadNote.dataset.ukMadeLine.replace('[date]', current.dispatch) : (leadNote.dataset.ukCharged || leadNote.textContent);
        if (badgeEl && st !== 'preorder' && current.lead) { badgeEl.textContent = current.lead; badgeEl.className = 'uk-badge ' + (st === 'quick' ? 'uk-badge--quick' : 'uk-badge--made'); }
        UK.dispatchBullets(root, st, current.lead);
      }

      /* ---------- gallery ---------- */
      var track = root.querySelector('[data-uk-gallery-track]');
      var thumbsWrap = root.querySelector('[data-uk-thumbs]');
      var aliases = parseAliases(data.aliases);
      function colourKeys(title) { var k = normColour(title); return [k].concat(aliases[k] || []); }
      function slideMatches(slide, keys) {
        var probe = normColour((slide.dataset.ukName || '') + ' ' + (slide.dataset.ukAlt || ''));
        return keys.some(function (k) { return k && probe.indexOf(k) > -1; });
      }
      /* which colour does a photo belong to? (its variant's own image, or exactly one colour name in the file name / alt) */
      function variantForSlide(slide) {
        if (!slide) return null;
        var byMedia = variants.filter(function (v) { return v.mediaId && String(v.mediaId) === slide.dataset.ukMediaId; });
        if (byMedia.length === 1) return byMedia[0];
        var hits = variants.filter(function (v) { return slideMatches(slide, colourKeys(v.title)); });
        return hits.length === 1 ? hits[0] : null;
      }
      /* Round 18: photos that belong only to a hidden colour (snippets/uk-hidden-colour.liquid) leave the gallery */
      (function dropHidden() {
        var hidden = (data.hiddenColours || []).filter(Boolean);
        if (!track || !hidden.length) return;
        var shownKeys = variants.map(function (v) { return colourKeys(v.title); });
        var hiddenKeys = hidden.map(function (t) { return colourKeys(t); });
        Array.prototype.slice.call(track.querySelectorAll('[data-uk-slide]')).forEach(function (slide) {
          var isHidden = hiddenKeys.some(function (k) { return slideMatches(slide, k); });
          var isShown = shownKeys.some(function (k) { return slideMatches(slide, k); }) || variants.some(function (v) { return v.mediaId && String(v.mediaId) === slide.dataset.ukMediaId; });
          if (isHidden && !isShown) {
            var t = thumbsWrap && thumbsWrap.querySelector('[data-uk-thumb][data-uk-media-id="' + slide.dataset.ukMediaId + '"]');
            if (t) t.remove();
            slide.remove();
          }
        });
      })();
      function syncThumbs(idx) {
        if (!thumbsWrap) return;
        Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-uk-thumb]')).forEach(function (t, j) {
          t.setAttribute('aria-current', String(idx === j));
        });
      }
      function orderGallery(variant) {
        if (!track) return;
        var slides = Array.prototype.slice.call(track.querySelectorAll('[data-uk-slide]'));
        var thumbs = thumbsWrap ? Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-uk-thumb]')) : [];
        var keys = colourKeys(variant.title);
        var mediaId = String(variant.mediaId || '');
        function rank(slide) {
          if (mediaId && slide.dataset.ukMediaId === mediaId) return -1;   /* the variant's own image leads */
          var mine = slideMatches(slide, keys);
          return (mine ? 0 : 10) + imageType((slide.dataset.ukName || '') + ' ' + (slide.dataset.ukAlt || ''));
        }
        var order = slides.map(function (sl, i) { return { sl: sl, i: i, r: rank(sl) }; }).sort(function (a, b) { return a.r - b.r || a.i - b.i; });
        order.forEach(function (o) { track.appendChild(o.sl); });
        var byId = {};
        thumbs.forEach(function (t) { byId[t.dataset.ukMediaId] = t; });
        order.forEach(function (o) { var t = byId[o.sl.dataset.ukMediaId]; if (t) thumbsWrap.appendChild(t); });
        track._ukQuiet = true;                /* the programmatic reset to slide 0 must not flip the colour back */
        track.scrollLeft = 0;
        syncThumbs(0);
        track.setAttribute('data-uk-current-media', order.length ? order[0].sl.dataset.ukMediaId : '');
      }
      if (thumbsWrap && track) {
        thumbsWrap.addEventListener('click', function (e) {
          var t = e.target.closest('[data-uk-thumb]');
          if (!t) return;
          var slides = Array.prototype.slice.call(track.querySelectorAll('[data-uk-slide]'));
          var i = slides.map(function (sl) { return sl.dataset.ukMediaId; }).indexOf(t.dataset.ukMediaId);
          if (i < 0) return;
          track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          syncThumbs(i);
        });
        track.addEventListener('scroll', function () {
          clearTimeout(track._ukT);
          track._ukT = setTimeout(function () {
            var idx = Math.round(track.scrollLeft / track.clientWidth);
            syncThumbs(idx);
            /* gallery → swatch: the photo on screen is the colour that gets ordered */
            if (track._ukQuiet) { track._ukQuiet = false; if (idx === 0) return; }
            var slides = Array.prototype.slice.call(track.querySelectorAll('[data-uk-slide]'));
            var v = variantForSlide(slides[idx]);
            if (v && v.id !== current.id) { current = v; render(); rematchAddons(); }
          }, 80);
        });
      }

      /* ---------- price ---------- */
      function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
      function unitPrice(q) { var price = current.price; tiers.forEach(function (t) { if (q >= t.min) price = t.price; }); return price; }
      function render() {
        var q = qty();
        var each = unitPrice(q);
        var line = each * q;
        if (eachEl) eachEl.textContent = data.simple ? (data.packSize > 1 ? UK.money(each) + ' · pack of ' + data.packSize + ' · ' + UK.money(Math.round(each / data.packSize)) + ' each' : UK.money(each) + ' ' + (data.eachWord || 'each')) : UK.money(each) + ' per ' + UK.unitWord(unit, 1) + (data.unitNote ? ' ' + data.unitNote : '');
        var qtyWord = root.querySelector('[data-uk-qty-word]');
        if (qtyWord) qtyWord.textContent = q + ' ' + UK.unitWord(unit, q) + (data.perBox > 1 ? ' (' + (q * data.perBox) + ' panels)' : '');
        if (totalEl) totalEl.textContent = UK.money(line);
        colourNames.forEach(function (el) { el.textContent = String(current.title || '').replace(/Gray/g, 'Grey'); });
        if (idInput) idInput.value = current.id;
        if (stickyPrice) stickyPrice.textContent = UK.money(line);
        if (stickyColour) stickyColour.textContent = current.title;
        ladder.forEach(function (b) {
          var min = Number(b.dataset.ukTier);
          var max = b.dataset.ukTierMax ? Number(b.dataset.ukTierMax) : Infinity;
          b.setAttribute('aria-pressed', String(q >= min && q <= max));
        });
        swatches.forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.ukSwatch) === current.id)); });
        var mine = basketLines[current.id];
        var updating = !!mine;            /* already in the basket: the button sets the quantity, it never adds on top */
        var atcText = updating ? 'Update basket to ' + q : (atc && atc.dataset.ukAtcText) || 'Add to basket';
        if (atc) {
          atc.disabled = false;             /* stock never blocks buying — lead time says when it ships */
          var label = atc.querySelector('[data-uk-atc-label]');
          if (label) label.textContent = atcText;
        }
        var stickyBtn2 = document.querySelector('[data-uk-sticky-atc-btn]');
        if (stickyBtn2) stickyBtn2.textContent = updating ? 'Update to ' + q : (current.state === 'preorder' ? atcText : 'Add to basket');
        if (stickyColour) stickyColour.textContent = data.simple ? q + ' × ' + current.title : q + ' ' + UK.unitWord(unit, q) + ' · ' + current.title;
        renderLead();
        if (typeof renderSample === 'function') renderSample();
        try { document.dispatchEvent(new CustomEvent('uk:variant', { detail: { id: current.id, handle: data.handle } })); } catch (e) {}
      }

      swatches.forEach(function (b) {
        b.addEventListener('click', function () {
          var v = variants.filter(function (x) { return x.id === Number(b.dataset.ukSwatch); })[0];
          if (!v) return;
          current = v;
          orderGallery(v);
          if (history.replaceState) { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url); }
          render();
          rematchAddons();
        });
      });
      ladder.forEach(function (b) { b.addEventListener('click', function () { if (qtyInput) qtyInput.value = b.dataset.ukTier; render(); }); });
      root.querySelectorAll('[data-uk-step]').forEach(function (b) {
        b.addEventListener('click', function () { if (!qtyInput) return; qtyInput.value = Math.max(1, qty() + Number(b.dataset.ukStep)); render(); });
      });
      if (qtyInput) qtyInput.addEventListener('input', render);

      /* ---------- mini calculator: "Not sure how many?" ---------- */
      var mini = root.querySelector('[data-uk-minicalc]');
      if (mini) {
        var mw = mini.querySelector('[data-uk-mini-w]'), mh = mini.querySelector('[data-uk-mini-h]');
        var mout = mini.querySelector('[data-uk-mini-out]'), mn = mini.querySelector('[data-uk-mini-n]'), mu = mini.querySelector('[data-uk-mini-unit]'), muse = mini.querySelector('[data-uk-mini-use]');
        var miniN = 0, miniDims = null;
        muse.dataset.ukLabel = muse.textContent.trim();
        function miniCalc() {
          var w = miniDims ? miniDims.get('w') : parseFloat(mw.value), h = miniDims ? miniDims.get('h') : parseFloat(mh.value);
          var cov = coverage > 0 ? coverage : 0.68;
          if (!(w > 0 && h > 0)) { miniN = 0; mout.hidden = true; muse.hidden = true; return; }
          miniN = Math.ceil(((w * h) / cov) * 1.08);
          mn.textContent = miniN;
          if (mu) mu.textContent = UK.unitWord(unit, miniN);
          mout.hidden = false; muse.hidden = false;
        }
        miniDims = UK.initDims ? UK.initDims(mini, miniCalc) : null;
        if (!miniDims) [mw, mh].forEach(function (el) { el.addEventListener('input', miniCalc); el.addEventListener('change', miniCalc); });
        muse.addEventListener('click', function () {
          if (!miniN || !qtyInput) return;
          qtyInput.value = miniN;
          render();
          muse.textContent = 'Set to ' + miniN + ' ✓';
          setTimeout(function () { muse.textContent = muse.dataset.ukLabel; }, 2000);
        });
      }

      /* ---------- add-ons: colour-matched, in the basket on tick ---------- */
      var addonRows = Array.prototype.slice.call(root.querySelectorAll('[data-uk-addon]'));
      var jump = root.querySelector('[data-uk-calc-jump]');
      if (jump) jump.addEventListener('click', function (e) {
        var target = document.querySelector('[data-uk-calc]'); if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(function () { var f = target.querySelector('[data-uk-rows] [data-uk-metric]:not([hidden]), [data-uk-rows] [data-uk-ft]:not([hidden]), [data-uk-calc-w]'); if (f) f.focus({ preventScroll: true }); }, 500);
      });
      var addonTotal = root.querySelector('[data-uk-addon-total]');
      if (addonTotal) addonTotal.dataset.ukEmpty = addonTotal.textContent;
      var addonData = {};
      (data.addons || []).forEach(function (a) { addonData[a.handle] = a; });
      function matchVariant(addon, colourTitle) {
        var list = (addon && addon.variants) || [];
        var mapped = UK.mapVariant(data.handle, colourTitle, UK.roleFor(addon && addon.handle));
        if (mapped) { var hit = list.filter(function (v) { return v.id === mapped; })[0]; if (hit) return hit; }
        var keys = colourKeys(colourTitle);
        if (list.length === 1 && /default title/i.test(list[0].title)) return list[0];
        return list.filter(function (v) { var t = normColour(v.title); return keys.some(function (k) { return k && t.indexOf(k) > -1; }); })[0] || null;
      }
      /* ---------- "Add a [colour] sample" — the sample variant matching the selected colour ---------- */
      var sampleBtn = root.querySelector('[data-uk-sample-add]');
      var sampleData = data.sample || null;
      function sampleVariant() { return sampleData ? matchVariant(sampleData, current.title) : null; }
      function renderSample() {
        if (!sampleBtn) return;
        var sv = sampleVariant();
        sampleBtn.hidden = !sv;
        var none = root.querySelector('[data-uk-sample-none]');
        if (none) { none.hidden = !!sv; if (!sv) none.textContent = (none.dataset.ukTpl || 'No [colour] sample yet — order [others] to feel the texture').replace('[colour]', current.title).replace('[others]', none.dataset.ukOthers || 'another colour'); }
        if (!sv) return;
        var tpl = sampleBtn.dataset.ukLabel || 'Add a [colour] sample — [price]';
        sampleBtn.dataset.ukVariant = sv.id;
        if (!sampleBtn.dataset.ukBusy) sampleBtn.textContent = tpl.replace('[colour]', current.title).replace('[price]', UK.money(sv.price));
      }
      var sampleErr = root.querySelector('[data-uk-sample-err]');
      function sampleError(msg) {
        if (!sampleErr) { UK.toast(msg); return; }
        sampleErr.textContent = msg; sampleErr.hidden = false;
        clearTimeout(sampleErr._t); sampleErr._t = setTimeout(function () { sampleErr.hidden = true; }, 8000);
      }
      if (sampleBtn) sampleBtn.addEventListener('click', function () {
        var sv = sampleVariant(); if (!sv || sampleBtn.dataset.ukBusy) return;
        sampleBtn.dataset.ukBusy = '1';
        if (sampleErr) sampleErr.hidden = true;
        var label = sampleBtn.textContent;
        var restore = function () { delete sampleBtn.dataset.ukBusy; sampleBtn.disabled = false; sampleBtn.textContent = label; renderSample(); };
        UK.busy(sampleBtn, true);
        var lead = UK.sampleStockLabel(sv.inStock !== false, sv.lead);
        var item = { id: sv.id, quantity: 1, properties: UK.leadProps(lead) };
        var req = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
        /* hard stop: whatever happens, the button is back within 8 s */
        var timer = new Promise(function (_, reject) { setTimeout(function () { reject(new Error('timeout')); }, 8000); });
        var added = false;
        Promise.race([req, timer]).then(function (r) {
          if (!r.ok) {
            return r.clone().json().catch(function () { return {}; }).then(function (d) {
              restore();
              sampleError((d && (d.description || d.message)) || ('Could not add this sample (HTTP ' + r.status + ')'));
            });
          }
          /* success: "Added \u2713" for two seconds, header count pulses, drawer opens with the refund line */
          added = true;
          sampleBtn.disabled = false; sampleBtn.innerHTML = 'Added \u2713';
          setTimeout(restore, 2000);
          return Promise.race([UK.afterAdd(r, { button: sampleBtn, panel: { refund: sampleData.refund ? [sampleData.refund] : [] } }), timer]).catch(function () {});
        }).catch(function (e) {
          restore();
          sampleError('Something went wrong \u2014 try again or see all samples.');
          UK.log('sample add failed: ' + (e && e.message));
        }).then(function () { if (added) return fetchCart().then(syncAddons); });
      });
      function rowState(row, text, isError) {
        var st = row.querySelector('[data-uk-addon-state]');
        if (!st) return;
        st.hidden = !text; st.textContent = text || ''; st.classList.toggle('is-error', !!isError);
      }
      function syncAddons(cart) {
        basketLines = {};
        var count = 0, sum = 0, ids = {};
        addonRows.forEach(function (row) { ((addonData[row.dataset.ukAddonHandle] || {}).variants || []).forEach(function (v) { ids[v.id] = true; }); });
        (cart.items || []).forEach(function (line) { basketLines[line.variant_id] = line; if (ids[line.variant_id]) { count += line.quantity; sum += line.final_line_price; } });
        UK.leadRender(cart);
        addonRows.forEach(function (row) {
          var vid = Number(row.dataset.ukVariant), input = row.querySelector('input');
          var inBasket = !!(vid && basketLines[vid]);
          input.checked = inBasket;
          if (inBasket) rowState(row, 'Added ✓ · in your basket');
          else if (!row.classList.contains('has-error')) rowState(row, '');
        });
        if (addonTotal) addonTotal.textContent = count ? count + (count === 1 ? ' extra' : ' extras') + ' in your basket · ' + UK.money(sum) : addonTotal.dataset.ukEmpty;
        if (stickyBasket) { stickyBasket.hidden = !(cart.item_count > 0); stickyBasket.textContent = 'Basket ' + UK.money(cart.total_price || 0); }
        render();
      }
      function fetchCart() {
        return UK.withTimeout(fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }), 6000).then(function (c) { return c || { items: [] }; });
      }
      function cartAdd(id, lead) { var item = { id: id, quantity: 1 }; if (lead) item.properties = UK.leadProps(lead); return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) }); }
      function addonLead(vid) { var found = null; Object.keys(addonData).forEach(function (h) { (addonData[h].variants || []).forEach(function (v) { if (v.id === vid) found = v.lead; }); }); return found; }
      function cartChange(key, quantity) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity }) }); }
      function rematchAddons() {
        var swaps = [];
        addonRows.forEach(function (row) {
          var v = matchVariant(addonData[row.dataset.ukAddonHandle], current.title);
          var old = Number(row.dataset.ukVariant) || 0;
          var title = row.querySelector('[data-uk-addon-title]'), price = row.querySelector('[data-uk-addon-price]');
          if (!v) {   /* no colour match: hide, or show as a "choose a colour" link — never add the wrong one */
            if (old && basketLines[old]) swaps.push({ remove: basketLines[old] });
            row.dataset.ukVariant = '';
            if (row.dataset.ukNomatch === 'link') {
              row.hidden = false; row.classList.add('is-link');
              if (title) title.textContent = row.dataset.ukLabel;
              if (price) price.textContent = '';
              var inp = row.querySelector('input'); if (inp) inp.checked = false;
              rowState(row, '');
            } else { row.hidden = true; }
            return;
          }
          row.hidden = false; row.classList.remove('is-link');
          if (title) title.textContent = row.dataset.ukLabel + ' · ' + current.title;
          if (price) price.textContent = UK.money(v.price);
          row.dataset.ukVariant = v.id;
          if (old && old !== v.id && basketLines[old]) swaps.push({ remove: basketLines[old], add: v.id });
        });
        var box = root.querySelector('[data-uk-addons]');
        if (box) box.hidden = addonRows.every(function (r) { return r.hidden; });   /* never an empty box */
        if (!swaps.length) return;
        var chain = Promise.resolve();
        swaps.forEach(function (sw) { chain = chain.then(function () { return cartChange(sw.remove.key, 0); }).then(function () { if (sw.add) return cartAdd(sw.add); }); });
        chain.then(fetchCart).then(syncAddons);
      }
      addonRows.forEach(function (row) {
        var input = row.querySelector('input');
        input.addEventListener('change', function () {
          if (row.dataset.ukBusy) { input.checked = !input.checked; return; }
          var vid = Number(row.dataset.ukVariant);
          if (!vid) { input.checked = false; if (row.classList.contains('is-link')) { var go = row.querySelector('.uk-addon__go'); if (go) window.location.href = go.href; } return; }
          row.dataset.ukBusy = '1';
          row.classList.remove('has-error');
          var flow;
          if (input.checked) {
            rowState(row, 'Adding…');
            flow = cartAdd(vid, addonLead(vid)).then(function (r) {
              if (!r.ok) {
                return r.clone().json().catch(function () { return {}; }).then(function (d) {
                  input.checked = false; row.classList.add('has-error');
                  rowState(row, (d && (d.description || d.message)) || 'Could not add this — please try again', true);
                });
              }
              return UK.afterAdd(r, { silent: true });   /* badge pulse + drawer contents, no drawer opening */
            });
          } else {
            var line = basketLines[vid];
            rowState(row, '');
            flow = line ? cartChange(line.key, 0).then(function (r) { if (typeof window.refreshCartContents === 'function') { try { window.refreshCartContents(r.clone()); } catch (e) {} } }) : Promise.resolve();
          }
          UK.withTimeout(flow.catch(function () { input.checked = false; row.classList.add('has-error'); rowState(row, 'Something went wrong — please try again', true); }), 8000)
            .then(fetchCart).then(syncAddons).then(function () { delete row.dataset.ukBusy; });
        });
      });

      /* ---------- add the panels (add-ons are already in the basket) ---------- */
      function addPanels(button) {
        var label = button.innerHTML;
        UK.busy(button, true);
        UK.setPanels(current.id, qty(), { button: button, lead: current.lead, unit: unit }).then(function () { setTimeout(function () { UK.busy(button, false, label); render(); }, 2000); })   /* re-render after the 2 s "Added ✓" flip so the label reads "Update basket to N", not the stale "Add to basket" */.then(fetchCart).then(syncAddons).then(function () { try { document.dispatchEvent(new CustomEvent('uk:cart')); } catch (e) {} });
      }
      document.addEventListener('uk:cart', function () { fetchCart().then(syncAddons); });
      var form = root.querySelector('[data-uk-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          addPanels(atc || form.querySelector('[type="submit"]'));
        }, true);
      }
      var stickyBtn = document.querySelector('[data-uk-sticky-atc-btn]');
      if (stickyBtn) stickyBtn.addEventListener('click', function (e) { e.preventDefault(); addPanels(stickyBtn); });
      var bar = document.querySelector('.uk-sticky-atc');
      var anchor = root.querySelector('[data-uk-buybox-anchor]');
      var seenButton = false;
      if (bar && anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          /* Round 9: on a phone Add to basket must be one tap away from the first paint, so the bar also shows
             while the real button is still below the fold — until the shopper has scrolled down to it. After
             that it behaves as before: visible only once the button has been scrolled past. */
          entries.forEach(function (entry) {
            var above = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            var below = !entry.isIntersecting && entry.boundingClientRect.top >= 0;
            if (entry.isIntersecting) seenButton = true;
            bar.classList.toggle('is-visible', above || (below && !seenButton));
            if (UK.floating) UK.floating();
          });
        }, { threshold: 0 }).observe(anchor);
      }

      orderGallery(current);
      render();
      rematchAddons();
      fetchCart().then(syncAddons);
    });
  }

  /* ---------------- image lightbox (product gallery, project gallery, samples, review photos) ----------------
     Never traps the user: closes on a tap anywhere outside the image, swipe down, Escape and the phone's Back
     button (a history state is pushed on open). Swipe left/right moves between images. Big X top-right on a
     dark scrim, "3 / 8" counter, "Tap anywhere to close" hint on first open. If it cannot render, no lightbox. */
  function initReviewPhotos(scope) {
    (scope || document).querySelectorAll('[data-uk-photos]').forEach(function (root) {
      if (root.dataset.ukPhotosReady) return;
      root.dataset.ukPhotosReady = '1';
      var items = function () { return Array.prototype.slice.call(root.querySelectorAll('[data-uk-photo]')); };
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-uk-photo]');
        if (!btn || !root.contains(btn)) return;
        var list = items();
        var srcs = list.map(function (b) { return b.dataset.ukPhoto; });
        var opened = false;
        try { opened = openLightbox(srcs, list.indexOf(btn)); } catch (err) { opened = false; }
        if (opened) { e.preventDefault(); e.stopPropagation(); }
        /* not opened: a link falls through to the image itself, a button does nothing — never a dead end */
      });
    });
  }
  UK.openLightbox = function (srcs, start) { try { return openLightbox(srcs, start); } catch (e) { return false; } };

  function openLightbox(srcs, start) {
    if (!srcs || !srcs.length) return false;
    /* a stale viewer (an earlier open that never finished closing) must never block the next tap */
    Array.prototype.slice.call(document.querySelectorAll('.uk-lb')).forEach(function (old) { try { old.remove(); } catch (e) {} });
    var i = Math.max(0, start || 0);
    /* Round 12: a native <dialog> in the browser's top layer — above every z-index, outside every stacking
       context and ancestor transform an app or the vendor theme may add. Falls back to a fixed div. */
    var canDialog = typeof HTMLDialogElement === 'function' && typeof HTMLDialogElement.prototype.showModal === 'function';
    var lb = document.createElement(canDialog ? 'dialog' : 'div');
    lb.className = 'uk-lb';
    if (!canDialog) { lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); }
    lb.setAttribute('aria-label', 'Image viewer');
    /* Critical geometry goes inline with !important so nothing else on the page — an app stylesheet, a vendor
       reset, a broken rule earlier in the cascade — can shrink or move the viewer. uk-theme.css only adds polish. */
    function force(el, props) { if (!el) return; for (var k in props) { try { el.style.setProperty(k, props[k], 'important'); } catch (e) {} } }
    force(lb, { position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', inset: '0', width: '100%', height: '100%', 'max-width': 'none', 'max-height': 'none', margin: '0', padding: '12px', border: '0', 'border-radius': '0', 'box-sizing': 'border-box', display: 'flex', 'flex-direction': 'column', 'align-items': 'center', 'justify-content': 'center', 'z-index': '2147483000', background: 'rgba(10,12,12,.94)', color: '#fff', overflow: 'hidden', opacity: '1', visibility: 'visible', transform: 'none', 'pointer-events': 'auto' });
    var showHint = false;
    try { showHint = !localStorage.getItem('uk-lb-hint'); } catch (e) { showHint = true; }
    lb.innerHTML =
      '<button class="uk-lb__close" type="button" aria-label="Close" data-uk-lb-close><span aria-hidden="true">&times;</span></button>' +
      '<div class="uk-lb__stage" data-uk-lb-stage><img class="uk-lb__img" alt="" data-uk-lb-img></div>' +
      '<div class="uk-lb__bar">' +
        (srcs.length > 1 ? '<button class="uk-lb__nav" type="button" data-uk-lb-prev aria-label="Previous image">‹ Previous</button>' : '<span></span>') +
        '<span class="uk-lb__count" data-uk-lb-count aria-live="polite"></span>' +
        (srcs.length > 1 ? '<button class="uk-lb__nav" type="button" data-uk-lb-next aria-label="Next image">Next ›</button>' : '<span></span>') +
      '</div>' +
      (showHint ? '<p class="uk-lb__hint" data-uk-lb-hint>Tap anywhere to close</p>' : '');
    var img = lb.querySelector('[data-uk-lb-img]'), count = lb.querySelector('[data-uk-lb-count]');
    force(lb.querySelector('[data-uk-lb-stage]'), { flex: '1 1 auto', 'min-height': '0', width: '100%', display: 'flex', 'align-items': 'center', 'justify-content': 'center', overflow: 'hidden' });
    force(img, { 'max-width': '100%', 'max-height': '100%', width: 'auto', height: 'auto', display: 'block', 'object-fit': 'contain', margin: '0', opacity: '1', visibility: 'visible' });
    var closeBtn = lb.querySelector('[data-uk-lb-close]');
    force(closeBtn, { position: 'absolute', top: '12px', right: '12px', width: '52px', height: '52px', 'min-width': '44px', 'min-height': '44px', display: 'flex', 'z-index': '2', opacity: '1', visibility: 'visible' });
    var closed = false, pushed = false;
    var prevBody = document.body.style.overflow, prevHtml = document.documentElement.style.overflow;
    function unlock() { document.body.style.overflow = prevBody; document.documentElement.style.overflow = prevHtml; document.documentElement.classList.remove('uk-lb-open'); }
    function draw() { img.src = srcs[i]; count.textContent = (i + 1) + ' / ' + srcs.length; }
    function next() { if (srcs.length < 2) return; i = (i + 1) % srcs.length; draw(); }
    function prev() { if (srcs.length < 2) return; i = (i - 1 + srcs.length) % srcs.length; draw(); }
    function close(fromHistory) {
      if (closed) return; closed = true;
      try { if (canDialog && lb.open) lb.close(); } catch (e) {}
      lb.remove();
      unlock();
      document.removeEventListener('keydown', key);
      window.removeEventListener('popstate', pop);
      window.removeEventListener('pagehide', onHide);
      if (pushed && !fromHistory) { try { history.back(); } catch (e) {} }
    }
    function key(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
    }
    function pop() { close(true); }
    function onHide() { unlock(); }
    lb.addEventListener('cancel', function (e) { e.preventDefault(); close(); });   /* dialog: Escape */
    lb.addEventListener('close', function () { close(); });                          /* dialog: closed by anything else */
    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-uk-lb-next]')) { next(); return; }
      if (e.target.closest('[data-uk-lb-prev]')) { prev(); return; }
      if (e.target === img) return;             /* the image itself: leave it (pinch/zoom) */
      close();                                   /* anywhere else — scrim, X, bar, hint — closes */
    });
    /* swipe: left/right = next/previous, down = close (pointer events cover touch and mouse) */
    var sx = 0, sy = 0, tracking = false;
    lb.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; tracking = true; });
    lb.addEventListener('pointerup', function (e) {
      if (!tracking) return; tracking = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) { swiped = true; if (dx < 0) next(); else prev(); }
      else if (dy > 80 && Math.abs(dy) > Math.abs(dx)) { swiped = true; close(); }
    });
    var swiped = false;
    lb.addEventListener('click', function (e) { if (swiped) { swiped = false; e.stopImmediatePropagation(); } }, true);
    img.addEventListener('error', function () { close(); });
    document.addEventListener('keydown', key);
    window.addEventListener('pagehide', onHide);
    /* the phone's Back button closes the viewer instead of leaving the page (not inside the theme editor, which owns navigation there) */
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    if (!designMode) { try { history.pushState({ ukLightbox: true }, ''); pushed = true; window.addEventListener('popstate', pop); } catch (e) { pushed = false; } }
    document.body.appendChild(lb);
    if (canDialog) { try { lb.showModal(); } catch (e) { try { lb.setAttribute('open', ''); } catch (e2) {} lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); } }
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('uk-lb-open');
    draw();
    try { closeBtn.focus(); } catch (e) {}
    if (showHint) { try { localStorage.setItem('uk-lb-hint', '1'); } catch (e) {} setTimeout(function () { var h = lb.querySelector('[data-uk-lb-hint]'); if (h) h.classList.add('is-gone'); }, 2600); }
    return true;
  }

  /* ---------------- Round 8: one colour normaliser for the whole theme ----------------
     ignores apostrophes and the possessive, gray = grey, drops "Stone Ledger –" prefixes */
  UK.normColour = function (t) {
    return String(t || '').toLowerCase().replace(/\u2019/g, "'").replace(/'s\b/g, '').replace(/'/g, '')
      .replace(/^\s*stone ledger\s*[-\u2013]\s*/, '').replace(/gray/g, 'grey').replace(/[^a-z0-9]/g, '');
  };
  /* colour mapping table from uk-settings: panel handle | colour | role:variantId … */
  UK.colourMap = function () {
    if (UK.__cmap) return UK.__cmap;
    var map = {}, el = document.querySelector('[data-uk-colour-map]'), text = '';
    try { text = JSON.parse(el.textContent) || ''; } catch (e) { text = ''; }
    String(text).split(/\r?\n/).forEach(function (line) {
      var parts = line.split('|').map(function (x) { return x.trim(); });
      if (parts.length < 2 || !parts[0] || parts[0][0] === '#') return;
      var entry = map[parts[0]] = map[parts[0]] || {};
      var roles = entry[UK.normColour(parts[1])] = {};
      parts.slice(2).forEach(function (kv) { var m = kv.match(/^([a-z]+)\s*:\s*(\d+)$/i); if (m) roles[m[1].toLowerCase()] = Number(m[2]); });
    });
    UK.__cmap = map;
    return map;
  };
  UK.mapVariant = function (handle, colour, role) {
    var e = UK.colourMap()[handle]; if (!e) return null;
    var r = e[UK.normColour(colour)]; return r && r[role] ? r[role] : null;
  };
  UK.roleFor = function (handle) {
    var h = String(handle || '');
    if (/sample/.test(h)) return 'sample';
    if (/corner/.test(h)) return 'corner';
    if (/ledge/.test(h)) return 'ledge';
    if (/starter/.test(h)) return 'starter';
    if (/touch/.test(h)) return 'touchup';
    return '';
  };

  /* ---------------- Round 8: lead times (site defaults from uk-settings) ---------------- */
  UK.lead = function () {
    var d = { quick: 'Quick ship', made: 'Made to order · 8–10 weeks', today: 'Ships today', next: 'Ships next working day', backorder: 'Back order — dispatched within 4 weeks', cutoff: 12, charged: 'Charged now. Cancel any time before dispatch for a full refund.', basket: 'Your order ships together:' };
    var o = (window.UK_SETTINGS && window.UK_SETTINGS.lead) || {};
    Object.keys(o).forEach(function (k) { if (o[k] !== undefined && o[k] !== null && o[k] !== '') d[k] = o[k]; });
    return d;
  };
  /* rank a lead-time line in days so the basket can show the LONGEST one */
  UK.leadDays = function (text) {
    var t = String(text || '').toLowerCase();
    if (!t) return 0;
    var m = t.match(/(\d+)\s*[–-]\s*(\d+)\s*week/); if (m) return Number(m[2]) * 7;
    m = t.match(/(\d+)\s*week/); if (m) return Number(m[1]) * 7;
    m = t.match(/(\d+)\s*day/); if (m) return Number(m[1]);
    if (/pre-order|preorder/.test(t)) return 60;
    if (/made to order|back-order|backorder/.test(t)) return 60;
    if (/next working day/.test(t)) return 1;
    /* "Ships from 1 October": an embargoed sample. Rank it by the real wait so the
       basket's "ships together" line picks the right one in a mixed basket; fall back
       to 30 days if the date cannot be read. */
    if (/ships from/.test(t)) {
      var m = String(text).match(/ships from\s+(\d{1,2}\s+[a-z]+|[a-z]+\s+\d{1,2})/i);
      var when = m ? Date.parse(m[1] + ' ' + new Date().getFullYear()) : NaN;
      if (isNaN(when)) return 30;
      var days = Math.ceil((when - Date.now()) / 86400000);
      return days > 0 ? days : 0;
    }
    return 0;
  };
  UK.leadProps = function (text) { return text ? { 'Lead time': text, '_lead_days': String(UK.leadDays(text)) } : null; };
  UK.longestLead = function (cart) {
    var best = null, bd = -1;
    ((cart && cart.items) || []).forEach(function (l) {
      var p = l.properties || {}; var t = p['Lead time']; if (!t) return;
      var d = Number(p._lead_days); if (isNaN(d)) d = UK.leadDays(t);
      if (d > bd) { bd = d; best = t; }
    });
    return best;
  };
  /* 30 Sep 2026 — basket quantity vs stock (Jeff's rule). When the basket holds more of a quick-ship
     colour than is in stock (every line of that colour counted together), that colour's lines are a
     back order: their "Lead time" becomes the back-order line, so the line, the "ships together" bar,
     checkout and the order itself all say so. Taking the quantity back down restores what the line
     said before (kept in _lead_was, hidden like every "_" property). Made-to-order, pre-order and
     dated items are never touched; nor is anything untracked or that stops selling at 0.
     UK.stockChanges is the rule, pure: cart + stock → the line changes to make. */
  UK.stockChanges = function (cart, stock, boText) {
    var items = (cart && cart.items) || [], totals = {}, out = [];
    items.forEach(function (l) { totals[l.variant_id] = (totals[l.variant_id] || 0) + l.quantity; });
    items.forEach(function (l, i) {
      var s = stock && stock[l.variant_id]; if (!s || s.k !== 'quick' || !s.t || !s.c) return;
      var p = l.properties || {}, t = p['Lead time'], switched = Object.prototype.hasOwnProperty.call(p, '_lead_was');
      var over = totals[l.variant_id] > Number(s.q), np = null;
      if (over && !switched && t !== boText && (!t || UK.leadDays(t) <= 1)) {
        np = Object.assign({}, p, { 'Lead time': boText, _lead_days: String(UK.leadDays(boText)), _lead_was: t || '-' });   /* '-' = it had no lead line; blank values can be dropped */
      } else if (!over && switched) {
        np = Object.assign({}, p); delete np._lead_was;
        if (p._lead_was && p._lead_was !== '-') { np['Lead time'] = p._lead_was; np._lead_days = String(UK.leadDays(p._lead_was)); }
        else { delete np['Lead time']; delete np._lead_days; }
      }
      if (np) out.push({ line: i + 1, quantity: l.quantity, properties: np });
    });
    return out;
  };
  UK.readCartStock = function () {
    return fetch('/cart?sections=uk-cart-stock', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) {
      var html = j && j['uk-cart-stock']; if (!html) return null;
      var m = String(html).match(/<script[^>]*data-uk-cart-stock[^>]*>([\s\S]*?)<\/script>/);
      return m ? JSON.parse(m[1]) : null;
    }).catch(function () { return null; });
  };
  var stockBusy = false, stockAgain = false;
  UK.stockSync = function (cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve(null);
    if (stockBusy) { stockAgain = true; return Promise.resolve(null); }
    stockBusy = true;
    var last = null;
    return UK.readCartStock().then(function (stock) {
      var todo = stock ? UK.stockChanges(cart, stock, UK.lead().backorder) : [];
      if (!todo.length) return null;
      /* one line at a time, by position: a new property changes that line's key, never its place */
      return todo.reduce(function (p, c) {
        return p.then(function () {
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: c.line, quantity: c.quantity, properties: c.properties }) })
            .then(function (r) { if (r.ok) last = r; });
        });
      }, Promise.resolve()).then(function () {
        if (!last) return null;
        if (typeof window.refreshCartContents === 'function' && document.querySelector('#offcanvas-cart')) { try { window.refreshCartContents(last.clone()); } catch (e) {} }
        return last.json().then(function (c) {
          UK.cartPageProps(c);
          stockSkip = true; try { UK.leadRender(c); } finally { stockSkip = false; }
          return c;
        });
      });
    }).catch(function () { return null; }).then(function (c) {
      stockBusy = false;
      if (stockAgain) { stockAgain = false; UK.refreshLead(); }
      return c;
    });
  };
  var stockSkip = false;
  /* the basket page prints properties in Liquid: keep its lines' keys and "Lead time" in step */
  UK.cartPageProps = function (cart) {
    var lines = document.querySelectorAll('[data-uk-cart-page] [data-uk-cart-line]');
    Array.prototype.forEach.call(lines, function (el, i) {
      var it = cart.items[i]; if (!it) return;
      el.dataset.ukKey = it.key;
      var t = (it.properties || {})['Lead time'];
      var prop = el.querySelector('[data-uk-prop="Lead time"]');
      if (!t) { if (prop) prop.remove(); return; }
      if (!prop) {
        prop = document.createElement('div'); prop.className = 'uk-small uk-muted uk-cart__prop'; prop.setAttribute('data-uk-prop', 'Lead time');
        var meta = el.querySelector('[data-uk-line-meta]'); if (meta) meta.insertAdjacentElement('afterend', prop); else return;
      }
      prop.textContent = 'Lead time: ' + t;
    });
  };
  /* 30 Sep 2026 — the product page's "same-day dispatch" bullet follows the selected colour: its own
     words while the colour is in stock, the colour's lead line (back order, made to order) when not. */
  UK.dispatchBullets = function (root, state, lead) {
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-uk-dispatch-bullet]'), function (li) {
      var span = li.querySelector('span') || li;
      var quick = li.getAttribute('data-uk-quick-text') || span.textContent;
      span.textContent = (state === 'quick' || !lead) ? quick : lead;
    });
  };
  /* samples: "Ships today" before the UK cut-off on a working day, else "next working day".
     A working day is Mon-Fri and not an England & Wales bank holiday. The list below is the same one
     as snippets/uk-ship-now.liquid (keep the two in step; extend both each year). */
  UK.bankHolidays = ['2026-01-01','2026-04-03','2026-04-06','2026-05-04','2026-05-25','2026-08-31','2026-12-25','2026-12-28','2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28','2028-01-03','2028-04-14','2028-04-17','2028-05-01','2028-05-29','2028-08-28','2028-12-25','2028-12-26'];
  UK.londonParts = function (now) {
    var o = { wd: '', hr: 0, ymd: '' };
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', hour12: false }).formatToParts(now || new Date());
      var y = '', m = '', d = '';
      p.forEach(function (x) {
        if (x.type === 'weekday') o.wd = x.value;
        if (x.type === 'hour') o.hr = Number(x.value) % 24;
        if (x.type === 'year') y = x.value;
        if (x.type === 'month') m = x.value;
        if (x.type === 'day') d = x.value;
      });
      o.ymd = y + '-' + m + '-' + d;
    } catch (e) {}
    return o;
  };
  UK.isWorkingDay = function (parts) {
    return !(parts.wd === 'Sat' || parts.wd === 'Sun' || UK.bankHolidays.indexOf(parts.ymd) !== -1);
  };
  UK.sampleStockLabel = function (inStock, override, now) {
    var L = UK.lead();
    if (!inStock) return override || L.backorder;
    var t = UK.londonParts(now);
    if (!t.ymd) return L.today;
    if (!UK.isWorkingDay(t) || t.hr >= Number(L.cutoff || 12)) return L.next;
    return L.today;
  };
  /* longest lead in the basket → sticky bars, the basket drawer, the cart page */
  UK.leadRender = function (cart) {
    if (!stockSkip && cart && cart.items && cart.items.length) UK.stockSync(cart);   /* basket vs stock, above */
    try { if (cart && cart.items && UK.lineMeta) UK.lineMeta(cart); } catch (e) {}
    var text = UK.longestLead(cart), L = UK.lead();
    document.querySelectorAll('[data-uk-sticky-lead],[data-uk-sbr-lead]').forEach(function (el) {
      el.hidden = !text; el.textContent = text ? (el.hasAttribute('data-uk-sbr-lead') ? text + ' · ' : text) : '';
    });
    var hosts = [];
    var body = document.querySelector('#offcanvas-cart .offcanvas-body'); if (body) hosts.push(body);
    document.querySelectorAll('form[action="/cart"],form[action="/cart/"]').forEach(function (f) { hosts.push(f); });
    hosts.forEach(function (h) {
      var bar = h.querySelector(':scope > .uk-leadbar');
      if (!text) { if (bar) bar.remove(); return; }
      if (!bar) { bar = document.createElement('div'); bar.setAttribute('data-uk-leadbar', ''); h.insertBefore(bar, h.firstChild); }
      bar.className = 'uk-leadbar' + (UK.leadDays(text) <= 1 ? ' uk-leadbar--quick' : '');
      bar.innerHTML = '<span></span>';
      bar.firstChild.textContent = L.basket + ' ';
      var b = document.createElement('b'); b.textContent = text; bar.firstChild.appendChild(b);
    });
  };
  /* every basket line (drawer and basket page) says how many and the unit price: "× 2 · £5.99 each" */
  UK.lineMeta = function (cart) {
    var items = (cart && cart.items) || [];
    var drawer = Array.prototype.slice.call(document.querySelectorAll('#offcanvas-cart [data-cart-line-item]'));
    drawer.forEach(function (el, i) {
      var it = items[i]; if (!it) return;
      var meta = el.querySelector('.uk-line-meta');
      if (!meta) { meta = document.createElement('span'); meta.className = 'uk-line-meta'; var host = el.querySelector('.col-8, .product-item-body') || el; host.appendChild(meta); }
      meta.textContent = '× ' + it.quantity + ' · ' + UK.money(it.final_price) + ' each';
    });
    document.querySelectorAll('[data-uk-cart-page] [data-uk-cart-line]').forEach(function (el) {
      var it = items.filter(function (x) { return x.key === el.dataset.ukKey; })[0]; if (!it) return;
      var meta = el.querySelector('[data-uk-line-meta]'); if (meta) meta.textContent = '× ' + it.quantity + ' · ' + UK.money(it.final_price) + ' each';
      var tot = el.querySelector('[data-uk-line-total]'); if (tot) tot.textContent = UK.money(it.final_line_price);
      var q = el.querySelector('[data-uk-cart-qty]'); if (q && String(q.value) !== String(it.quantity)) q.value = it.quantity;
    });
    var sub = document.querySelector('[data-uk-cart-subtotal]'); if (sub && cart) sub.textContent = UK.money(cart.total_price);
  };
  /* basket page: steppers and Remove change the line in place, nothing reloads */
  function initCartPage(scope) {
    (scope || document).querySelectorAll('[data-uk-cart-page]').forEach(function (form) {
      if (form.dataset.ukReady) return; form.dataset.ukReady = '1';
      var change = function (key, qty) {
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
          .then(function (r) { return r.json(); }).then(function (cart) {
            if (qty === 0) { var line = form.querySelector('[data-uk-cart-line][data-uk-key="' + key + '"]'); if (line) line.remove(); }
            if (!cart.items || !cart.items.length) { window.location.reload(); return cart; }
            UK.lineMeta(cart); UK.leadRender(cart);
            var badge = document.querySelector('.cart-count-badge'); if (badge) { badge.textContent = cart.item_count; badge.hidden = !cart.item_count; }
            return cart;
          }).catch(function () { UK.toast('Could not update the basket — please try again'); });
      };
      form.addEventListener('click', function (e) {
        var st = e.target.closest('[data-uk-cart-step]'); var rm = e.target.closest('[data-uk-cart-remove]');
        if (st) { e.preventDefault(); var line = st.closest('[data-uk-cart-line]'); var q = line.querySelector('[data-uk-cart-qty]'); var n = Math.max(0, (parseInt(q.value, 10) || 0) + Number(st.dataset.ukCartStep)); q.value = n; change(line.dataset.ukKey, n); }
        if (rm) { e.preventDefault(); change(rm.closest('[data-uk-cart-line]').dataset.ukKey, 0); }
      });
      form.addEventListener('change', function (e) {
        var q = e.target.closest('[data-uk-cart-qty]'); if (!q) return;
        change(q.closest('[data-uk-cart-line]').dataset.ukKey, Math.max(0, parseInt(q.value, 10) || 0));
      });
    });
  }
  UK.initCartPage = initCartPage;
  UK.refreshLead = function () {
    if (!document.querySelector('#offcanvas-cart,form[action="/cart"],[data-uk-sticky-lead],[data-uk-sbr-lead]')) return Promise.resolve();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { UK.leadRender(c); UK.lineMeta(c); }).catch(function () {});
  };
  /* samples page: refund line(s) chosen by what is in the basket (panel/brick vs Stick-A-Stone) */
  UK.refundLinesFor = function (cart) {
    var root = document.querySelector('[data-uk-samples-page]');
    if (!root) return [];
    var kinds = {};
    root.querySelectorAll('[data-uk-sample-card]').forEach(function (c) { var b = c.querySelector('[data-uk-variant]'); if (b) kinds[b.dataset.ukVariant] = c.dataset.ukKind || 'panel'; });
    var has = {};
    ((cart && cart.items) || []).forEach(function (l) { var k = kinds[String(l.variant_id)]; if (k) has[k] = true; });
    var out = [];
    if (has.panel && root.dataset.ukRefundPanel) out.push(root.dataset.ukRefundPanel);
    if (has.sas && root.dataset.ukRefundSas) out.push(root.dataset.ukRefundSas);
    if (!out.length && (has.panel || has.sas) && root.dataset.ukRefundLine) out.push(root.dataset.ukRefundLine);
    return out;
  };
  /* the "just added" panel at the top of the basket drawer (also the deferred samples summary) */
  UK.showAdded = function (cart, opts) {
    opts = opts || {};
    var drawer = document.querySelector('#offcanvas-cart');
    var body = drawer && drawer.querySelector('.offcanvas-body');
    var canOpen = drawer && body && window.bootstrap && window.bootstrap.Offcanvas;
    function fallbackToast() { UK.toast(opts.title || 'Added to basket', [{ href: '/cart', text: 'View basket' }, { href: '/checkout', text: 'Checkout' }]); }
    if (!canOpen) { fallbackToast(); return; }
    var line = opts.line || (cart && cart.items && cart.items[0]);
    var p = document.createElement('div');
    p.className = 'uk-added';
    p.setAttribute('data-uk-added', '');
    var img = !opts.summary && line && line.image ? '<img src="' + line.image.replace(/(\.[a-z]+)(\?|$)/i, '_112x112$1$2') + '" alt="">' : '';
    var title = opts.title || (line ? (line.product_title + (line.variant_title ? ' · ' + line.variant_title : '')) : 'Added to your basket');
    var sub = opts.sub !== undefined ? opts.sub : (line ? ('Added to your basket' + (line.quantity > 1 ? ' × ' + line.quantity : '')) : '');
    var refunds = UK.refundLinesFor(cart).concat(opts.refund || []);
    p.innerHTML =
      '<div class="uk-added__row">' + img + '<div><div class="' + (opts.summary ? 'uk-added__sum' : 'uk-added__title') + '"></div><div class="uk-added__sub"></div></div></div>' +
      '<div class="uk-added__actions"><a class="uk-btn uk-btn--blue" href="/checkout">Checkout</a><button class="uk-btn uk-btn--ghost" type="button" data-uk-keep>Keep shopping</button></div>';
    p.querySelector('.uk-added__row div > div').textContent = title;
    p.querySelector('.uk-added__sub').textContent = sub;
    var actions = p.querySelector('.uk-added__actions');
    refunds.forEach(function (t) { var r = document.createElement('p'); r.className = 'uk-added__refund'; r.textContent = t; p.insertBefore(r, actions); });
    body.querySelectorAll('[data-uk-added]').forEach(function (old) { old.remove(); });
    body.insertBefore(p, body.firstChild);
    var inst = window.bootstrap.Offcanvas.getOrCreateInstance(drawer);
    p.querySelector('[data-uk-keep]').addEventListener('click', function () { inst.hide(); });
    try { inst.show(); } catch (e) { fallbackToast(); }
    if (cart) UK.leadRender(cart);
  };
  /* units for the calculators: m · cm · ft/in, remembered on the device; values always kept in metres.
     Rows can be added later (project calculator) — call .rescan() after inserting them. */
  UK.initDims = function (container, onChange) {
    var unitsEl = container.querySelector('[data-uk-units]');
    var unit = 'm';
    try { unit = localStorage.getItem('uk-unit') || 'm'; } catch (e) {}
    if (['m', 'cm', 'ft'].indexOf(unit) < 0) unit = 'm';
    var list = [];
    function fmt(n) { return n ? String(Math.round(n * 100) / 100) : ''; }
    function paintOne(d) {
      var m = d.val;
      if (unit === 'ft' && d.ft && d.inch) {
        d.metric.hidden = true; if (d.box) d.box.hidden = false;
        var totalIn = m / 0.0254, ft = Math.floor(totalIn / 12 + 1e-9), inch = Math.round(totalIn - ft * 12);
        if (inch === 12) { ft++; inch = 0; }
        d.ft.value = m ? String(ft) : ''; d.inch.value = m ? String(inch) : '';
        /* 30 Sep 2026 — hints are words, never numbers: a number in a box reads as a size someone
           entered, and the calculator must never suggest a wall nobody measured */
        d.ft.placeholder = 'ft'; d.inch.placeholder = 'in';
      } else {
        d.metric.hidden = false; if (d.box) d.box.hidden = true;
        d.metric.value = unit === 'cm' ? fmt(m * 100) : fmt(m);
        d.metric.step = unit === 'cm' ? '1' : '0.1';
        d.metric.placeholder = d.key === 'w' ? 'width' : 'height';
      }
      if (d.label) d.label.textContent = unit === 'ft' ? 'ft/in' : unit;
    }
    function paint() {
      list.forEach(paintOne);
      container.querySelectorAll('[data-uk-unit-label]').forEach(function (l) { l.textContent = unit === 'ft' ? 'ft/in' : unit; });
      if (unitsEl) unitsEl.querySelectorAll('[data-uk-unit]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.ukUnit === unit)); });
    }
    function read(d) {
      if (unit === 'ft' && d.ft && d.inch) d.val = ((parseFloat(d.ft.value) || 0) * 12 + (parseFloat(d.inch.value) || 0)) * 0.0254;
      else { var v = parseFloat(d.metric.value) || 0; d.val = unit === 'cm' ? v / 100 : v; }
    }
    function rescan() {
      container.querySelectorAll('[data-uk-dim]').forEach(function (el) {
        if (el._ukDim) return;
        var d = { el: el, key: el.dataset.ukDim, metric: el.querySelector('[data-uk-metric]'), ft: el.querySelector('[data-uk-ft]'), inch: el.querySelector('[data-uk-in]'), box: el.querySelector('.uk-dim__ftin'), label: el.querySelector('[data-uk-unit-label]'), val: 0 };
        if (!d.metric) return;
        d.val = parseFloat(el.dataset.ukMetres) || parseFloat(d.metric.value) || 0;
        el._ukDim = d; list.push(d);
        [d.metric, d.ft, d.inch].forEach(function (inp) {
          if (!inp) return;
          ['input', 'change'].forEach(function (ev) { inp.addEventListener(ev, function () { read(d); if (onChange) onChange(); }); });
        });
        paintOne(d);
      });
      list = list.filter(function (d) { return container.contains(d.el); });
    }
    if (unitsEl) unitsEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-uk-unit]'); if (!b) return;
      unit = b.dataset.ukUnit;
      try { localStorage.setItem('uk-unit', unit); } catch (x) {}
      paint(); if (onChange) onChange();
    });
    rescan(); paint();
    if (!list.length) return null;      /* legacy markup without unit fields: caller wires its own inputs */
    return {
      get: function (k) { var d = list.filter(function (x) { return x.key === k; })[0]; return d ? d.val : 0; },
      getEl: function (el) { var d = el && el._ukDim; return d ? d.val : 0; },
      setEl: function (el, m) { var d = el && el._ukDim; if (d) { d.val = m; paintOne(d); } },
      unit: function () { return unit; },
      rescan: rescan
    };
  };
  /* add panels, or when that colour is already in the basket set its quantity — never add on top */
  UK.setPanels = function (variantId, qty, opts) {
    opts = opts || {};
    var props = Object.assign({}, opts.lead ? UK.leadProps(opts.lead) : {}, opts.props || {});
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (cart) {
      var line = cart && (cart.items || []).filter(function (l) { return l.variant_id === Number(variantId); })[0];
      if (line) {
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: qty, properties: Object.keys(props).length ? props : undefined }) })
          .then(function (r) { return UK.afterAdd(r, { button: opts.button, silent: opts.silent, panel: { title: line.product_title + (line.variant_title ? ' · ' + line.variant_title : ''), sub: 'Basket updated to ' + qty + ' ' + UK.unitWord(opts.unit || 'panel', qty) } }); });
      }
      return UK.addToCart([{ id: Number(variantId), quantity: qty, properties: opts.props || {} }], { button: opts.button, silent: opts.silent, lead: opts.lead });
    }).catch(function () { UK.toast('Something went wrong. Please try again.'); });
  };

  /* ---------------- boot ---------------- */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-uk-carousel]').forEach(initCarousel);
    initVideoTriggers(scope);
    initPosterClips(scope);
    initBeforeAfter(scope);
    initAccordions(scope);
    initCalculators(scope);
    initSampleHubs(scope);
    initProduct(scope);
    initPriceLines(scope);
    initWallCost(scope);
    initReviewPhotos(scope);
    initPhotoGrids(scope);
    initRegionBar();
    if (UK.bootExtra) UK.bootExtra(scope);
  }
  UK.boot = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Theme Editor: re-init the section that was just re-rendered */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();

/* ==========================================================================
   ROUND 2 — video, samples-by-range, range nav, floating widgets, debug flag
   ========================================================================== */
(function () {
  'use strict';
  var UK = window.UK;
  if (!UK || UK.__round2) return;
  UK.__round2 = true;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = function () { return window.matchMedia('(min-width: 900px)').matches; };

  /* ---------- self-hosted video: desktop loop / mobile tap ---------- */
  function makeVideo(src, opts) {
    var v = document.createElement('video');
    v.src = src;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    if (opts.loop) { v.loop = true; v.muted = true; v.setAttribute('muted', ''); v.autoplay = true; v.setAttribute('aria-hidden', 'true'); }
    else { v.controls = true; }
    v.preload = 'metadata';
    return v;
  }
  function initVideos(scope) {
    (scope || document).querySelectorAll('[data-uk-video-wrap]').forEach(function (wrap) {
      if (wrap.dataset.ukVideoReady) return;
      wrap.dataset.ukVideoReady = '1';
      var src = wrap.dataset.ukSrc;
      var mode = wrap.dataset.ukMode;
      var play = wrap.querySelector('[data-uk-video-play]');
      if (!src) return;
      if (mode === 'loop' && isDesktop() && !reducedMotion) {
        var loop = makeVideo(src, { loop: true });
        wrap.appendChild(loop);
        wrap.classList.add('is-looping');
        loop.play && loop.play().catch(function () { wrap.classList.remove('is-looping'); loop.remove(); });
        return;
      }
      if (play) {
        play.addEventListener('click', function () {
          var v = makeVideo(src, { loop: false });
          wrap.appendChild(v);
          wrap.classList.add('is-playing');
          v.play && v.play().catch(function () {});
        });
      }
    });
    /* hero: template holds the loop; only cloned on desktop */
    (scope || document).querySelectorAll('[data-uk-hero-video]').forEach(function (media) {
      if (media.dataset.ukHeroReady) return;
      media.dataset.ukHeroReady = '1';
      var tpl = media.querySelector('template[data-uk-hero-loop]');
      if (!tpl || !isDesktop() || reducedMotion) return;
      var v = tpl.content.firstElementChild.cloneNode(true);
      v.muted = true;
      media.appendChild(v);
      v.play && v.play().catch(function () { v.remove(); });
    });
  }

  /* ---------- samples by range: Add / Remove per colour, no limit ---------- */
  function initSbr(scope) {
    (scope || document).querySelectorAll('[data-uk-sbr]').forEach(function (root) {
      if (root.dataset.ukSbrReady) return;
      root.dataset.ukSbrReady = '1';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-uk-sbr-item]'));
      var bar = root.querySelector('[data-uk-sbr-bar]');
      var countEl = root.querySelector('[data-uk-sbr-count]');
      var totalEl = root.querySelector('[data-uk-sbr-total]');
      var ids = items.map(function (b) { return Number(b.dataset.ukVariant); });
      var lines = {}, cart = null, pending = 0, idleT = null;
      var delay = (Number(root.dataset.ukDrawerDelay) || 8) * 1000;
      var cardOf = function (b) { return b.closest('[data-uk-sample-card]') || b; };
      UK.log('samples page: ' + items.length + ' swatches, no cap, drawer after ' + delay / 1000 + 's idle');

      /* availability line per card: site wording + the UK same-day cut-off */
      root.querySelectorAll('[data-uk-sample-card]').forEach(function (card) {
        var av = card.querySelector('[data-uk-avail]'); if (!av) return;
        var inStock = card.dataset.ukStock !== '0';
        av.textContent = UK.sampleStockLabel(inStock, card.dataset.ukLead);
        av.classList.toggle('uk-avail--ok', inStock); av.classList.toggle('uk-avail--wait', !inStock);
      });
      function leadFor(b) { var av = cardOf(b).querySelector('[data-uk-avail]'); return av ? av.textContent.trim() : ''; }

      function paint(b, on) {
        cardOf(b).setAttribute('aria-pressed', String(on));
        if (!b.dataset.ukHold) b.textContent = on ? 'Remove' : 'Add';
        b.classList.toggle('is-in-cart', on);
        b.disabled = false;               /* never disabled by stock or basket contents */
      }
      function showError(b, msg) {
        var card = cardOf(b);
        var old = card.querySelector('.uk-sample__err'); if (old) old.remove();
        var el = document.createElement('span');
        el.className = 'uk-sample__err'; el.setAttribute('role', 'alert'); el.textContent = msg;
        card.appendChild(el); card.classList.add('has-error');
        setTimeout(function () { el.remove(); card.classList.remove('has-error'); }, 6000);
        UK.toast(msg);
      }
      function sampleTotals() {
        var count = 0, total = 0;
        Object.keys(lines).forEach(function (k) { count += lines[k].quantity; total += lines[k].final_line_price; });
        return { count: count, total: total };
      }
      function sync() {
        return UK.withTimeout(fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          cart = c; lines = {};
          (c.items || []).forEach(function (line) { if (ids.indexOf(line.variant_id) > -1) lines[line.variant_id] = line; });
          var t = sampleTotals();
          items.forEach(function (b) { paint(b, !!lines[Number(b.dataset.ukVariant)]); });
          if (countEl) countEl.textContent = t.count;
          root.querySelectorAll('[data-uk-sbr-word]').forEach(function (w) { w.textContent = t.count === 1 ? 'sample' : 'samples'; });
          if (totalEl) totalEl.textContent = UK.money(t.total);
          if (bar) bar.hidden = t.count === 0;
          document.documentElement.style.setProperty('--uk-bar-h', bar && !bar.hidden ? bar.offsetHeight + 'px' : '0px');
          UK.leadRender(c);
          if (UK.floating) UK.floating();
          UK.log('cart.js: ' + (c.item_count || 0) + ' items, ' + t.count + ' samples');
        }).catch(function (e) { UK.log('cart.js failed: ' + e); }), 6000);
      }

      /* the drawer opens ONCE per run of taps: after `delay` of no further taps, or when the last group scrolls past */
      function openDrawerNow() {
        clearTimeout(idleT);
        if (!pending) return;
        pending = 0;
        var t = sampleTotals();
        if (!t.count) return;
        UK.showAdded(cart, { summary: true, title: t.count + ' ' + (t.count === 1 ? 'sample' : 'samples') + ' · ' + UK.money(t.total), sub: '' });
        UK.log('drawer opened with ' + t.count + ' samples');
      }
      function scheduleDrawer() { pending++; clearTimeout(idleT); idleT = setTimeout(openDrawerNow, delay); }
      var groups = root.querySelectorAll('.uk-sbr__group');
      var last = groups[groups.length - 1];
      if (last && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (!en.isIntersecting && en.boundingClientRect.bottom < 0 && pending > 0) openDrawerNow(); });
        }, { threshold: 0 }).observe(last);
      }

      function toggle(b) {
        if (b.dataset.ukBusy) return;
        var id = Number(b.dataset.ukVariant);
        var line = lines[id];
        var t0 = Date.now();
        b.dataset.ukBusy = '1';
        var req;
        if (line) {
          req = fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
        } else {
          var item = { id: id, quantity: 1 };
          var lead = leadFor(b); if (lead) item.properties = UK.leadProps(lead);
          req = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
        }
        var flow = req.then(function (r) {
          UK.log((line ? 'remove ' : 'add ') + id + ' → HTTP ' + r.status + ' in ' + (Date.now() - t0) + 'ms');
          if (!r.ok) {
            return r.clone().json().catch(function () { return {}; }).then(function (d) {
              var msg = (d && (d.description || d.message)) || ('Could not ' + (line ? 'remove' : 'add') + ' this sample (HTTP ' + r.status + ')');
              UK.log('  store said: ' + JSON.stringify(d).slice(0, 300));
              showError(b, msg);
            });
          }
          if (line) {
            if (typeof window.refreshCartContents === 'function') { try { window.refreshCartContents(r.clone()); } catch (e) {} }
            return;
          }
          /* silent: badge pulses and the drawer contents refresh, but it does not open per tap */
          return UK.afterAdd(r, { button: b, card: cardOf(b), silent: true }).then(function () {
            b.dataset.ukHold = '1';
            b.textContent = 'Added ✓';
            setTimeout(function () { delete b.dataset.ukHold; b.textContent = lines[id] ? 'Remove' : 'Add'; }, 2000);
            scheduleDrawer();
          });
        }).catch(function (e) { UK.log('request failed: ' + e); showError(b, 'Something went wrong. Please try again.'); });
        /* whatever happens above, the button is usable again within 8 s */
        UK.withTimeout(flow, 8000).then(sync).then(function () { delete b.dataset.ukBusy; });
      }
      items.forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); toggle(b); }); });
      /* the whole card is the tap target — image or name toggles exactly like the button, one action per tap */
      root.querySelectorAll('[data-uk-sample-card]').forEach(function (card) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('[data-uk-sbr-item]') || e.target.closest('a') || e.target.closest('[data-uk-zoom]')) return;
          var b = card.querySelector('[data-uk-sbr-item]');
          if (b) toggle(b);
        });
      });
      sync();
    });
  }

  /* ---------- header height for the sticky range nav / rail ---------- */
  function measureHeader() {
    var h = 0;
    document.querySelectorAll('.sticky-top, [id*="__navbar"].sticky-top, [id*="__announcement-bar"].sticky-top').forEach(function (el) {
      var cs = getComputedStyle(el);
      if ((cs.position === 'sticky' || cs.position === 'fixed') && el.getBoundingClientRect().top <= 1) h = Math.max(h, el.getBoundingClientRect().bottom);
    });
    document.documentElement.style.setProperty('--uk-header-h', Math.round(h) + 'px');
  }

  /* ---------- floating widgets: park bottom-right, above sticky bars; pad the page ---------- */
  /* ---------- every phone number is a tel: link, every WhatsApp number a wa.me link — even in free text ---------- */
  UK.linkifyPhones = function (scope) {
    var settings = window.UK_SETTINGS || {};
    var digits = function (v) { return String(v || '').replace(/\D/g, '').replace(/^44/, '0'); };
    var wa = digits(settings.whatsapp || '07441 920001');
    var re = /(\+44\s?\d{2,4}[\s-]?\d{3}[\s-]?\d{3,4}|\b0\d{3,4}[\s-]?\d{3}[\s-]?\d{3,4}\b)/g;
    var root = scope || document.body;
    if (!root || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !/\d{5}/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p || p.closest('a, script, style, textarea, input, select, button, [contenteditable], [data-uk-nolink]')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var text = n.nodeValue, last = 0, m, frag = document.createDocumentFragment(), hit = false;
      re.lastIndex = 0;
      while ((m = re.exec(text))) {
        var d = digits(m[1]);
        if (d.length < 10) continue;
        hit = true;
        frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var a = document.createElement('a');
        a.setAttribute('data-uk-auto-link', d === wa ? 'whatsapp' : 'tel');
        if (d === wa) { a.href = 'https://wa.me/44' + d.slice(1); a.rel = 'noopener'; }
        else a.href = 'tel:+44' + d.slice(1);
        a.textContent = m[1];
        frag.appendChild(a);
        last = m.index + m[1].length;
      }
      if (!hit) return;
      frag.appendChild(document.createTextNode(text.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  };
  UK.floating = function () {
    var settings = window.UK_SETTINGS || {};
    var bars = Array.prototype.slice.call(document.querySelectorAll('.uk-sticky-atc.is-visible, .uk-sbr__bar:not([hidden])'));
    var barH = bars.reduce(function (m, b) { return Math.max(m, b.offsetHeight); }, 0);
    /* The page padding only ever grows: shrinking it while a bar hides near the foot of a page clamps the
       scroll position and the content jumps under the shopper's finger. */
    var padNow = parseFloat(document.documentElement.style.getPropertyValue('--uk-bar-h')) || 0;
    document.documentElement.style.setProperty('--uk-bar-h', Math.max(padNow, barH) + 'px');
    var tallest = barH;
    if (settings.moveWhatsapp !== false) {
      Array.prototype.slice.call(document.body.children).forEach(function (el) {
        if (el.classList.contains('shopify-section') || el.id === 'main' || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
        if (el.classList.contains('uk-sticky-atc') || el.classList.contains('uk-sbr__bar') || el.classList.contains('uk-modal') || el.classList.contains('uk-toast')) return;
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed' || cs.display === 'none') return;
        var r = el.getBoundingClientRect();
        var nearBottom = window.innerHeight - r.bottom < 120;
        if (!nearBottom || r.height > 200 || r.width > 320) return;
        el.classList.add('uk-float-moved');
        tallest = Math.max(tallest, barH + r.height + 24);
        /* an app may render its bubble inside a wrapper: push the inner absolutely-positioned child too */
        Array.prototype.slice.call(el.querySelectorAll('*')).slice(0, 12).forEach(function (child) {
          var ccs = getComputedStyle(child);
          if (ccs.position === 'fixed') child.classList.add('uk-float-moved');
        });
      });
    }
    document.documentElement.style.setProperty('--uk-body-pad', tallest + 'px');
  };

  /* ---------- ?debug=sections ---------- */
  function initDebug() {
    var settings = window.UK_SETTINGS || {};
    if (settings.debugAllowed === false) return;
    if (!/[?&]debug=sections/.test(location.search)) return;
    document.documentElement.classList.add('uk-debug');
    document.querySelectorAll('.shopify-section').forEach(function (sec, i) {
      var named = sec.querySelector('[data-uk-name]');
      var label = (i + 1) + '. ' + (named ? 'UK ' + named.dataset.ukName : (sec.firstElementChild && sec.firstElementChild.className ? sec.firstElementChild.className.split(' ')[0] : 'theme section'));
      sec.setAttribute('data-uk-debug', label + '  #' + sec.id.replace('shopify-section-', ''));
      /* dead-space rule: no more than 48px of empty space at the top or bottom of a section on a phone */
      var box = sec.getBoundingClientRect();
      /* content = leaf elements, plus anything drawn as a box (cards, tiles, tables) — their own padding is not dead space */
      var kids = Array.prototype.slice.call(sec.querySelectorAll('*')).filter(function (el) {
        var r = el.getBoundingClientRect();
        if (!(r.height > 0 && r.width > 0)) return false;
        if (el.children.length === 0 || /IMG|VIDEO|BUTTON|A|H1|H2|H3|P|SPAN|INPUT|TABLE/.test(el.tagName)) return true;
        var cs = getComputedStyle(el);
        return parseFloat(cs.borderTopWidth) > 0 || (cs.backgroundColor !== 'rgba(0, 0, 0, 0)' && cs.backgroundColor !== 'transparent');
      });
      if (kids.length && box.height > 0) {
        var top = Math.min.apply(null, kids.map(function (el) { return el.getBoundingClientRect().top; })) - box.top;
        var bottom = box.bottom - Math.max.apply(null, kids.map(function (el) { return el.getBoundingClientRect().bottom; }));
        var limit = window.innerWidth < 768 ? 48 : 80;
        if (top > limit || bottom > limit) sec.setAttribute('data-uk-gap', 'gap top ' + Math.round(top) + 'px / bottom ' + Math.round(bottom) + 'px');
      }
      /* home-page rule: no section taller than ~two phone screens; it should link out instead */
      if (document.body.classList.contains('page-type-index') && sec.getBoundingClientRect().height > 1600) {
        sec.setAttribute('data-uk-too-tall', String(Math.round(sec.getBoundingClientRect().height)));
      }
    });
  }

  /* ---------- hub sticky bar is always on while on mobile ---------- */
  function initHubBar(scope) {
    (scope || document).querySelectorAll('[data-uk-hub-bar]').forEach(function (bar) {
      bar.classList.add('is-visible');
    });
  }

  UK.bootExtra = function (scope) {
    initVideos(scope);
    initSbr(scope);
    initHubBar(scope);
    measureHeader();
    UK.floating();
  };
  window.addEventListener('load', function () { measureHeader(); initDebug(); setTimeout(UK.floating, 800); setTimeout(UK.floating, 2500); });
  window.addEventListener('resize', function () { measureHeader(); UK.floating(); });
  window.addEventListener('updated.ecomify.cart', function () { UK.floating(); });
  if (document.readyState !== 'loading') UK.bootExtra(document);
})();

/* ==========================================================================
   ROUND 4 §2–§3 — header (mega-menu, mobile drawer), predictive search, synonyms
   ========================================================================== */
(function () {
  'use strict';
  var UK = window.UK;
  if (!UK || UK.__round4) return;
  UK.__round4 = true;

  /* ---------- synonyms: "a <> b" widens the search, "term => /url" redirects ---------- */
  function readSynonyms() {
    var el = document.querySelector('[data-uk-synonyms]');
    var text = '';
    try { text = el ? JSON.parse(el.textContent) : ''; } catch (e) { text = ''; }
    var pairs = [], redirects = [];
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var m;
      if ((m = line.match(/^\s*(.+?)\s*<>\s*(.+?)\s*$/))) pairs.push([m[1].toLowerCase(), m[2].toLowerCase()]);
      else if ((m = line.match(/^\s*(.+?)\s*=>\s*(\S+)\s*$/))) redirects.push([m[1].toLowerCase(), m[2]]);
    });
    return { pairs: pairs, redirects: redirects };
  }
  UK.searchRoute = function (q) {
    var syn = readSynonyms();
    var norm = String(q || '').toLowerCase().replace(/\s+/g, ' ').trim();
    if (!norm) return { q: q };
    for (var i = 0; i < syn.redirects.length; i++) {
      var term = syn.redirects[i][0];
      var re = new RegExp('(^|\\W)' + term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(\\W|$)');
      if (norm === term || re.test(norm)) return { redirect: syn.redirects[i][1], q: q };
    }
    var out = norm;
    syn.pairs.forEach(function (p) {
      var re = new RegExp('\\b(' + p[0] + '|' + p[1] + ')\\b', 'g');
      if (re.test(out)) out = out.replace(re, '(' + p[0] + ' OR ' + p[1] + ')');
    });
    return { q: out };
  };
  function initSearchForms(scope) {
    (scope || document).querySelectorAll('[data-uk-searchform]').forEach(function (form) {
      if (form.dataset.ukReady) return;
      form.dataset.ukReady = '1';
      form.addEventListener('submit', function (e) {
        var input = form.querySelector('[name="q"]');
        if (!input) return;
        var route = UK.searchRoute(input.value);
        if (route.redirect) { e.preventDefault(); window.location.href = route.redirect; return; }
        if (route.q && route.q !== input.value) input.value = route.q;
      });
    });
  }

  /* ---------- predictive search (Shopify's suggest endpoint) ---------- */
  function money(v) { return UK.money(Math.round(parseFloat(v) * 100)); }
  function renderPredictive(box, data, q) {
    var r = (data && data.resources && data.resources.results) || {};
    var products = r.products || [], collections = r.collections || [], pages = r.pages || [];
    box.innerHTML = '';
    if (!products.length && !collections.length && !pages.length) {
      box.innerHTML = '<p class="uk-predictive__label">No matches yet — keep typing, or try a range name</p>';
      return;
    }
    function add(label, items, fn) {
      if (!items.length) return;
      var l = document.createElement('p'); l.className = 'uk-predictive__label'; l.textContent = label; box.appendChild(l);
      items.forEach(function (it) { box.appendChild(fn(it)); });
    }
    add('Panels', products, function (p) {
      var a = document.createElement('a'); a.href = p.url;
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : '';
      var colours = (p.variants || []).length;
      a.innerHTML = (img ? '<img alt="" width="48" height="48">' : '') + '<span><b></b><small></small></span>';
      if (img) a.querySelector('img').src = img;
      a.querySelector('b').textContent = p.title;
      a.querySelector('small').textContent = 'from ' + money(p.price) + (colours > 1 ? ' · ' + colours + ' colours' : '');
      return a;
    });
    add('Ranges & collections', collections, function (c) { var a = document.createElement('a'); a.href = c.url; a.innerHTML = '<span><b></b></span>'; a.querySelector('b').textContent = c.title; return a; });
    add('Pages', pages, function (c) { var a = document.createElement('a'); a.href = c.url; a.innerHTML = '<span><b></b></span>'; a.querySelector('b').textContent = c.title; return a; });
    var all = document.createElement('a'); all.className = 'uk-predictive__all'; all.href = '/search?q=' + encodeURIComponent(q) + '&type=product,page,article'; all.textContent = 'See all results for “' + q + '”'; box.appendChild(all);
  }
  function initPredictive(scope) {
    (scope || document).querySelectorAll('[data-uk-predictive]').forEach(function (input) {
      if (input.dataset.ukReady) return;
      input.dataset.ukReady = '1';
      var form = input.closest('form');
      var box = form && form.querySelector('[data-uk-predictive-results]');
      if (!box) return;
      var timer, last = '', ctrl;
      function close() { box.hidden = true; }
      function run() {
        var q = input.value.trim();
        if (q.length < 2) { close(); return; }
        var route = UK.searchRoute(q);
        var qq = route.q || q;
        if (qq === last && !box.hidden) return;
        last = qq;
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = '/search/suggest.json?q=' + encodeURIComponent(qq) + '&resources[type]=product,collection,page&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
        fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { return r.json(); })
          .then(function (data) { renderPredictive(box, data, q); box.hidden = false; })
          .catch(function () {});
      }
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
      input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && box.children.length) box.hidden = false; });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key === 'ArrowDown' && !box.hidden) { e.preventDefault(); var f = box.querySelector('a'); if (f) f.focus(); }
      });
      box.addEventListener('keydown', function (e) {
        var links = Array.prototype.slice.call(box.querySelectorAll('a'));
        var i = links.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) links[i - 1].focus(); else input.focus(); }
        if (e.key === 'Escape') { close(); input.focus(); }
      });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    });
  }

  /* ---------- header: mega-menu + mobile drawer ---------- */
  function initHeader(scope) {
    (scope || document).querySelectorAll('[data-uk-header]').forEach(function (header) {
      if (header.dataset.ukReady) return;
      header.dataset.ukReady = '1';
      var toggle = header.querySelector('[data-uk-mega-toggle]');
      var mega = header.querySelector('[data-uk-mega]');
      var hoverT, openedAt = 0;
      function openMega() { if (!mega) return; mega.hidden = false; toggle.setAttribute('aria-expanded', 'true'); openedAt = Date.now(); }
      function closeMega() { if (!mega) return; mega.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
      if (toggle && mega) {
        /* hover opens on pointer devices; a click straight after the hover-open must not close it again */
        toggle.addEventListener('click', function () { if (mega.hidden) openMega(); else if (Date.now() - openedAt > 400) closeMega(); });
        var item = toggle.parentElement;
        item.addEventListener('mouseenter', function () { clearTimeout(hoverT); if (window.matchMedia('(hover:hover)').matches) openMega(); });
        item.addEventListener('mouseleave', function () { hoverT = setTimeout(closeMega, 160); });
        header.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mega.hidden) { closeMega(); toggle.focus(); } });
        document.addEventListener('click', function (e) { if (!mega.hidden && !item.contains(e.target)) closeMega(); });
        mega.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) closeMega(); });
      }

      var drawer = document.getElementById(header.querySelector('[data-uk-drawer-open]') ? header.querySelector('[data-uk-drawer-open]').getAttribute('aria-controls') : 'uk-drawer');
      var opener = header.querySelector('[data-uk-drawer-open]');
      if (!drawer || !opener) return;
      var panel = drawer.querySelector('.uk-drawer__panel');
      var lastFocus;
      function openDrawer() {
        lastFocus = document.activeElement;
        drawer.hidden = false;
        if (panel) panel.setAttribute('aria-modal', 'true');   /* only while it is actually modal */
        document.body.classList.add('uk-drawer-open');
        opener.setAttribute('aria-expanded', 'true');
        var cur = drawer.querySelector('[aria-current="page"]');
        if (cur) { var grp = cur.closest('.uk-drawer__list'); if (grp) { grp.hidden = false; var b = drawer.querySelector('[aria-controls="' + grp.id + '"]'); if (b) b.setAttribute('aria-expanded', 'true'); } }
        setTimeout(function () { (drawer.querySelector('[data-uk-drawer-close]') || panel).focus(); }, 30);
      }
      function closeDrawer() {
        drawer.hidden = true;
        if (panel) panel.removeAttribute('aria-modal');
        document.body.classList.remove('uk-drawer-open');
        opener.setAttribute('aria-expanded', 'false');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      opener.addEventListener('click', openDrawer);
      drawer.querySelectorAll('[data-uk-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeDrawer(); return; }
        if (e.key === 'Tab') { /* keep focus inside */
          var f = Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled])')).filter(function (el) { return el.offsetParent !== null; });
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
        }
      });
      drawer.querySelectorAll('[data-uk-drawer-acc]').forEach(function (b) {
        b.addEventListener('click', function () {
          var open = b.getAttribute('aria-expanded') === 'true';
          b.setAttribute('aria-expanded', String(!open));
          var list = document.getElementById(b.getAttribute('aria-controls'));
          if (list) list.hidden = open;
        });
      });
      UK.closeDrawer = closeDrawer;
    });
  }

  UK.initHeader = initHeader;
  UK.initPredictive = initPredictive;
  /* ---------- contact page: Google Static Maps image (no clickable map) ---------- */
  function initStaticMap(scope) {
    (scope || document).querySelectorAll('[data-uk-static-map]').forEach(function (box) {
      if (box.dataset.ukReady) return;
      box.dataset.ukReady = '1';
      var keyEl = document.querySelector('[data-uk-maps-key]');
      var key = '';
      try { key = keyEl ? (JSON.parse(keyEl.textContent) || '') : ''; } catch (e) {}
      if (!key) return;
      var q = box.dataset.ukMapQuery || '';
      var url = 'https://maps.googleapis.com/maps/api/staticmap?center=' + encodeURIComponent(q) + '&zoom=' + (box.dataset.ukMapZoom || 15) + '&size=640x320&scale=2&maptype=' + (box.dataset.ukMapType || 'hybrid') + '&markers=' + encodeURIComponent('color:red|' + q) + '&key=' + encodeURIComponent(key);
      var img = document.createElement('img');
      img.className = 'uk-address__map';
      img.alt = 'Satellite map showing our Sheffield warehouse';
      img.width = 1280; img.height = 640; img.loading = 'lazy'; img.decoding = 'async';
      img.src = url;
      img.addEventListener('load', function () { box.replaceWith(img); });
    });
  }
  function boot4(scope) { initHeader(scope); initPredictive(scope); initSearchForms(scope); initStaticMap(scope); }
  var prevExtra = UK.bootExtra;
  UK.bootExtra = function (scope) { if (prevExtra) prevExtra(scope); boot4(scope); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot4(document); });
  else boot4(document);
})();

/* ==========================================================================
   ROUND 8 — info-page banner stripping, header dropdowns, contact subject,
   basket lead-time line on every page
   ========================================================================== */
(function () {
  var UK = window.UK;
  if (!UK || UK.__round8) return;
  UK.__round8 = true;

  /* information pages: strip hand-written banner styling (backgrounds, gradients, padding,
     radius, white text, flex card rows) — content untouched, only the styling wrappers */
  function initProseStrip(scope) {
    (scope || document).querySelectorAll('[data-uk-strip]').forEach(function (root) {
      if (root.dataset.ukStripped) return;
      root.dataset.ukStripped = '1';
      var kill = ['background', 'background-color', 'background-image', 'padding', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-radius', 'box-shadow', 'border', 'border-top', 'border-right', 'border-bottom', 'border-left', 'border-width', 'border-color', 'border-style', 'color', 'max-width', 'min-height', 'font-family', 'font-size', 'line-height', 'letter-spacing', 'text-transform', 'gap', 'flex', 'flex-wrap', 'justify-content', 'align-items', 'margin-left', 'margin-right', 'margin', 'width'];
      root.querySelectorAll('[style]').forEach(function (el) {
        if (el.tagName === 'IMG' || el.tagName === 'VIDEO' || el.tagName === 'IFRAME') return;
        var st = el.style;
        kill.forEach(function (prop) { st.removeProperty(prop); });
        if (/flex|grid/.test(st.display)) st.removeProperty('display');
        if (st.textAlign === 'center') st.removeProperty('text-align');
        if (!el.getAttribute('style') || !el.getAttribute('style').trim()) el.removeAttribute('style');
      });
      root.querySelectorAll('font[color]').forEach(function (f) { f.removeAttribute('color'); });
      /* a <style> block pasted into the page body is a styling wrapper too: neutralise its backgrounds/colours */
      root.querySelectorAll('style').forEach(function (st) {
        st.textContent = st.textContent.replace(/(^|[;{\s])(background(-[a-z]+)?|color|padding(-[a-z]+)?|border-radius|box-shadow|border(-[a-z]+)?|max-width|font-family|font-size)\s*:[^;}]*(;|(?=}))/gi, '$1');
      });
    });
  }

  /* header: top-level items with children (Fitting guide) open a small dropdown */
  function initHeaderDrops(scope) {
    (scope || document).querySelectorAll('[data-uk-header]').forEach(function (header) {
      if (header.dataset.ukDropsReady) return;
      header.dataset.ukDropsReady = '1';
      var toggles = Array.prototype.slice.call(header.querySelectorAll('[data-uk-drop-toggle]'));
      if (!toggles.length) return;
      function closeAll(except) {
        toggles.forEach(function (t) {
          if (t === except) return;
          var m = document.getElementById(t.getAttribute('aria-controls'));
          if (m) m.hidden = true; t.setAttribute('aria-expanded', 'false');
        });
      }
      toggles.forEach(function (t) {
        var menu = document.getElementById(t.getAttribute('aria-controls'));
        if (!menu) return;
        var item = t.parentElement, hoverT, openedAt = 0;
        function open() { closeAll(t); menu.hidden = false; t.setAttribute('aria-expanded', 'true'); openedAt = Date.now(); }
        function close() { menu.hidden = true; t.setAttribute('aria-expanded', 'false'); }
        t.addEventListener('click', function () { if (menu.hidden) open(); else if (Date.now() - openedAt > 400) close(); });
        item.addEventListener('mouseenter', function () { clearTimeout(hoverT); if (window.matchMedia('(hover:hover)').matches) open(); });
        item.addEventListener('mouseleave', function () { hoverT = setTimeout(close, 160); });
        item.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) { close(); t.focus(); } });
        menu.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
        document.addEventListener('click', function (e) { if (!menu.hidden && !item.contains(e.target)) close(); });
      });
    });
  }

  /* contact page: ?subject=… pre-fills a subject field (sent with the form) and the message */
  function initContactSubject() {
    var q;
    try { q = new URLSearchParams(window.location.search).get('subject'); } catch (e) { q = null; }
    if (!q) return;
    document.querySelectorAll('[data-uk-subject]').forEach(function (i) {
      i.value = q;
      var f = i.closest('[data-uk-subject-field]'); if (f) f.hidden = false;
    });
    var body = document.querySelector('textarea[name="contact[body]"]');
    if (body && !body.value) body.value = /fire/i.test(q) ? 'Please send me the full fire test report for Lightning Ridge (EN 13501-1, B-s1, d0).' : q;
    document.querySelectorAll('a[href^="mailto:"]').forEach(function (a) {
      try { var u = a.getAttribute('href'); a.setAttribute('href', u + (u.indexOf('?') > -1 ? '&' : '?') + 'subject=' + encodeURIComponent(q)); } catch (e) {}
    });
  }

  function boot8(scope) { initProseStrip(scope); initHeaderDrops(scope); }
  UK.initProseStrip = initProseStrip;
  var prevExtra = UK.bootExtra;
  UK.bootExtra = function (scope) { if (prevExtra) prevExtra(scope); boot8(scope); };
  function start() {
    boot8(document);
    initContactSubject();
    UK.refreshLead();
    window.addEventListener('updated.ecomify.cart', function () { setTimeout(UK.refreshLead, 50); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
